import {
    AnimationStyles,
    FontWeights,
    IColumn,
    ICommandBarItemProps,
    IDropdownOption,
    IStackTokens,
    mergeStyles,
    mergeStyleSets
} from '@fluentui/react';
import { RootState } from 'app/store';
import { UpdateColumnByConfig } from 'components/controls/CustomDetailList/CustomDetailList';
import { ICustomDetailListConfiguration } from 'components/controls/CustomDetailList/ICustomDetailListConfiguration';
import {
    filterPredicateColumnFAM,
    filterPredicateColumnPropertyName,
    filterPredicateColumnPropertyString,
    onRenderColumnFAM,
    onRenderColumnRef,
    sortPredicateColumnFAM,
    sortPredicateColumnPropertyName,
    sortPredicateColumnPropertyString
} from 'components/controls/Grid';
import { EValidationSeverity } from 'components/controls/ValidationView/ValidationView.type';
import { EControlType } from 'components/ControlWrapper';
import saveAs from 'file-saver';
import { IGCData } from 'global/Reducer/dataSlice';
import { setProcessing } from 'global/Reducer/statusSlice';
import Formatters from 'global/Utility/Formatters';
import { addNMonthsToDateString, ArrayToLookupByPredicate, ArrayToLookupByPredicateWithMap, dateFromOADate, formatDate, jsonClone, timestamp } from 'global/Utility/TSFunctions';
import { applyVisibility, ApplyVisibilityFields, applyVisibilityNonstandard, applyVisibilityNonstandardTemplate, BuildVisibilityScope } from 'global/Visibility/GlobalVisibility';
import { IFieldReference } from 'global/Visibility/IFieldReference';
import { IVisibilityScope } from 'global/Visibility/IVisibilityScope.type';
import {
    bcbs_groupconfigurationsnapshot as IXrmOptions_bcbs_groupconfigurationsnapshot,
    bcbs_opportunityoption as IXrmOptions_bcbs_opportunityoption,
    bcbs_opportunityproduct as IXrmOptions_bcbs_opportunityproduct,
} from "model/AttributeOptionSets.type";
import {
    $att_$cobra_$bcbs_cancellationeffectivedate_id,
    $att_$dental_$bcbs_cancellationeffectivedate_id,
    $att_$dental_$bcbs_payrunoutclaimsmonths_id,
    $att_$dental_$bcbs_runoutclaimsenddate_id,
    $att_$fees_and_premiums_$bcbs_bccadminid_id,
    $att_$fees_and_premiums_$bcbs_billgroupcode_id,
    $att_$fees_and_premiums_$bcbs_concessionamount_id,
    $att_$fees_and_premiums_$bcbs_eechpepmpertier_id,
    $att_$fees_and_premiums_$bcbs_eesppepmpertier_id,
    $att_$fees_and_premiums_$bcbs_employeeplus2dependentsrate_id,
    $att_$fees_and_premiums_$bcbs_employeeplusonechildrate_id,
    $att_$fees_and_premiums_$bcbs_familypepmpertier_id,
    $att_$fees_and_premiums_$bcbs_fee_feeamount_id,
    $att_$fees_and_premiums_$bcbs_fee_feetype_id,
    $att_$fees_and_premiums_$bcbs_guaranteecode_id,
    $att_$fees_and_premiums_$bcbs_perscriptonsite_id,
    $att_$fees_and_premiums_$bcbs_scothersplit_id,
    $att_$fees_and_premiums_$bcbs_showasseparateitemonbill_id,
    $att_$fees_and_premiums_$bcbs_singlepepmpertier_id,
    $att_$fees_and_premiums_$bcbs_tppepmpertier_id,
    $att_$group_configuration_$bcbs_cancellationeffectivedate_id,
    $att_$group_configuration_$bcbs_payrunoutclaimshowmanymonths_id,
    $att_$group_configuration_$bcbs_runoutclaimsenddate_id,
    $att_$group_configuration_$bcbs_stoplosspending_id,
    $att_$group_number_$bcbs_cancellationeffectivedate_id,
    $att_$group_number_$bcbs_payrunoutclaimshowmanymonths_id,
    $att_$group_number_$bcbs_runoutclaimsenddate_id,
    $att_$hra_$bcbs_hracancellationeffectivedate_id,
    $att_$hra_$bcbs_hrapayrunoutclaimshowmanymonths_id,
    $att_$hra_$bcbs_hrarunoutclaimsenddate_id,
    $att_$medical_$bcbs_cancellationeffectivedate_id,
    $att_$medical_$bcbs_payrunoutclaimsmonths_id,
    $att_$medical_$bcbs_runoutclaimsenddate_id,
    $att_$non_standard_$bcbs_benefitdefinition_id,
    $att_$non_standard_template_$bcbs_nst_effectivedate_id,
    $att_$pharmacy_$bcbs_cancellationeffectivedate_id,
    $att_$pharmacy_$bcbs_payrunoutclaimsmonths_id,
    $att_$pharmacy_$bcbs_runoutclaimsenddate_id,
    $att_$vision_$bcbs_cancellationeffectivedate_id,
    $att_$vision_$bcbs_payrunoutclaimsmonths_id,
    $att_$vision_$bcbs_runoutclaimsenddate_id
} from "model/ConfigAttributeConstants";
import {
    $cat_$ancillary_id,
    $cat_$cobra_id,
    $cat_$dental_id,
    $cat_$fsa_id,
    $cat_$group_configuration_id,
    $cat_$group_number_id,
    $cat_$hra_id,
    $cat_$hsa_id,
    $cat_$medical_id,
    $cat_$pharmacy_id, $cat_$plan_id, $cat_$vision_id
} from "model/ConfigCategoryConstants";
import {
    $oset_$fee_fee_type_$pepm_per_tier_id,
    $oset_$fee_fee_type_$per_employee_per_month_pepm_id
} from "model/ConfigOptionSetConstants";
import {
    account as IXrmTypes_account,
    bcbs_config_attribute as IXrmTypes_bcbs_config_attribute,
    bcbs_config_category as IXrmTypes_bcbs_config_category,
    bcbs_config_masterattribute as IXrmTypes_bcbs_config_masterattribute,
    bcbs_config_section as IXrmTypes_bcbs_config_section,
    bcbs_config_tab as IXrmTypes_bcbs_config_tab,
    bcbs_config_tierlevel as IXrmTypes_bcbs_config_tierlevel,
    bcbs_config_tierset as IXrmTypes_bcbs_config_tierset,
    bcbs_groupconfigurationsnapshot as IXrmTypes_bcbs_groupconfigurationsnapshot,
    bcbs_opportunitybenefit as IXrmTypes_bcbs_opportunitybenefit,
    bcbs_opportunityoption as IXrmTypes_bcbs_opportunityoption,
    bcbs_opportunityproduct as IXrmTypes_bcbs_opportunityproduct,
    bcbs_quoterequest as IXrmTypes_bcbs_quoterequest,
} from "model/CRM";
import {
    Ibcbs_config_attribute_extended as ICustomXrmTypes_Ibcbs_config_attribute_extended
} from 'model/CRM.type';
import {
    EBenefitStatus as FAM_EBenefitStatus,
    EGroupConfigurationStatus as FAM_EGroupConfigurationStatus,
    EProduct as FAM_EProduct,
    IAccountsReceivable as FAM_IAccountsReceivable,
    IBenefit as FAM_IBenefit,
    IBenefitRef as FAM_IBenefitRef,
    IBooleanValue as FAM_IBooleanValue,
    ICESNumber as FAM_ICESNumber,
    IDateValue as FAM_IDateValue,
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IFeesAndPremiums as FAM_IFeesAndPremiums,
    IFlexibleField as FAM_IFlexibleField,
    IFlexibleFieldSet as FAM_IFlexibleFieldSet,
    IFlexibleFieldValue as FAM_IFlexibleFieldValue,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    IGroupNumber as FAM_IGroupNumber,
    IMultiselectOptionSetValue as FAM_IMultiselectOptionSetValue,
    IMultiselectOptionSetValueValue as FAM_IMultiselectOptionSetValueValue,
    INonStandard as FAM_INonStandard,
    INonStandardTemplate as FAM_INonStandardTemplate,
    INumberValue as FAM_INumberValue,
    IOpportunityProductOptionBenefit as FAM_IOpportunityProductOptionBenefit,
    IOptionSetValue as FAM_IOptionSetValue,
    IPlan as FAM_IPlan,
    IRef as FAM_IRef,
    IStopLoss as FAM_IStopLoss,
    IStringValue as FAM_IStringValue,
    ITemplateRelationship as FAM_ITemplateRelationship,
    ITierDefinition as FAM_ITierDefinition,
    ITierLevel as FAM_ITierLevel,
    TBenefitStatusOptionSetValue as FAM_TBenefitStatusOptionSetValue,
    TDeactivateOptions as FAM_TDeactivateOptions,
    TFieldType as FAM_TFieldType,
    TGroupConfigurationStatusOptionSetValue as FAM_TGroupConfigurationStatusOptionSetValue,
    TGuid as FAM_TGuid,
    TProductOptionSetValue as FAM_TProductOptionSetValue,
    TTierLevels as FAM_TTierLevels,
    TValue as FAM_TValue,
    IGroupConfigurationData
} from 'model/FlexibleAttributeModel';
import { FlexibleFieldGenerator } from 'model/FlexibleFieldGenerator';
import { IExtendedColumn } from 'model/IExtendedColumn';
import { $matt_$fees_and_premiums_$bcbs_attributeset_fee_id } from "model/MasterAttributeConstants";
import { blankSnapshot } from 'model/snapshotTemplate';
import { Dispatch } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ITierChange, ITierLevelChange } from 'views/TierWizard';
import { Constants } from './Constants';
import { IApplicationContext } from './Context';

// const ignoreColumns = ['@odata.etag',
//     '_owningbusinessunit.*',
//     '_createdby_value.*',
//     'modifiedon.*',
//     '_owninguser_value.*',
//     '_modifiedby_value.*',
//     'createdon.*',
//     '_ownerid_value.*',
//     'overriddencreatedon',
//     '_modifiedonbehalfby_value',
//     'utcconversiontimezonecode',
//     '_createdonbehalfby_value',yb
//     '_owningteam_value',
//     'timezoneruleversionnumber',
//     'versionnumber@OData.*',
//     'bcbs_sortorder@OData.Community.Display.V1.FormattedValue',
//     '.*@Microsoft.Dynamics.CRM.lookuplogicalname',
//     '.*@Microsoft.Dynamics.CRM.associatednavigationproperty',
//     '.*@OData.Community.Display.V1.FormattedValue',
// ]
enum CachePolicy {
    // re
    CacheOnly,
    CacheAndUpdate,
    CacheAndUpdateDaily,
    CacheAndUpdateBackendToken
}

export const panelButtonsStyles = { root: { marginRight: 8, minWidth: '100px' } };
export const sectionStackTokens: IStackTokens = { childrenGap: 30 };
//TODO move to module construct
export const fadeIn = mergeStyles(AnimationStyles.fadeIn500, {});
export const slideRightIn400 = mergeStyles(AnimationStyles.slideRightIn40, {});
export const noOp = () => undefined;

export const appStyles = mergeStyleSets({
    button: {
        width: 130,
    },
    callout: {
        width: 450,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    calloutNarrow: {
        width: 450,
        maxWidth: '90%',
        padding: '8px',
    },
    calloutCopy: {
        padding: '15px 15px',
        overflowY: 'hidden'
    },
    calloutWide: {
        width: 600,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    calloutView: {
        width: 650,
    },
    calloutUltraWide: {
        width: 800,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    costshareCallout: {
        width: 500,
        Height: 500,
        maxWidth: '90%',
        maxHeight: '300px',
    },
    title: {
        fontWeight: FontWeights.semilight,
        marginBottom: '5px',
        paddingTop: '4px',
        paddingBottom: '3px',
        borderBottom: '1px solid gray',
        // backgroundColor: 'rgb(0, 120, 212)',
        // backgroundColor: 'gray',
        // textAlign: 'center',
        // color: 'white',

        // backgroundColor: 'gray',
        // color: 'white',
        // padding: '5px',
        // borderRadius: '5px'

    },
    calloutContent: {
        marginBottom: 12,
        fontWeight: FontWeights.semilight,
    },
    link: {
        display: 'block',
        marginTop: 20,
    },
    cardPadding: {
        paddingInlineStart: '20px'
    }
});


export const textProp = {
    root: {
        style: {
            width: '100%',
            minHeight: '58px',
        }
    },
    label: {

    },
    textStyles: {
        root: {
            display: 'block',
            paddingTop: '4px',
            padding: '6px',
            // backgroundColor: 'rgba(128,128,128,0.05)',
            border: '1px solid lightgray',
            borderRadius: '4px',
            minHeight: '18px'
        }
    }
};


export const styleSummary: Record<string, React.CSSProperties> = {
    "dl": {
        margin: '15px',
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        gap: '5px',
    },
    "dt": {
        gridColumn: 1,
        fontWeight: 680,
        textAlign: 'right',
        padding: '2px',
    },
    "dd": {
        padding: '2px',
    }
}


export const routeConstructor = () => {

}

export const friendlyValueToFlexibleFieldValue = (
    config: FAM_IGroupConfigurationConfig,
    valueText: string,
    configAttribute: IXrmTypes_bcbs_config_attribute,
    masterAttribute: IXrmTypes_bcbs_config_masterattribute,
    lookupValue: FAM_IEntityReferenceValue | null
) => {

    if (valueText === null) {
        return null;
    }
    else if (valueText === '(clear)') {
        return null;
    } else if (valueText === '') {
        return null;
    }


    const control = masterAttribute.bcbs_attributetypecode as EControlType;

    switch (control) {
        case EControlType.text:
        case EControlType.multiText:
        case EControlType.currency:
            {
                const value: FAM_IStringValue = {
                    type: "string",
                    value: valueText
                }
                return value;
            }

        case EControlType.date:
            {

                let dateValueText = '';

                if (valueText) {
                    // TODO \d{0,4}

                    // e.g. 5/23/22 10:45 AM 
                    // e.g. 44704.44792
                    const isExcelNumber = /^\d{5}\.?\d*$/.test(valueText);

                    if (isExcelNumber) {
                        const dt = dateFromOADate(parseFloat(valueText));
                        dateValueText = formatDate(dt, 'local:yyyy-MM-dd');

                    } else {

                        const isDate = !isNaN(Date.parse(valueText));

                        if (isDate) {
                            let dateValueTextConverted = valueText;

                            const isYYYYMMDD = /^\d\d\d\d-\d\d?-\d\d?$/.test(valueText);
                            if (isYYYYMMDD) {
                                dateValueTextConverted = dateValueTextConverted + 'T00:00:00';
                            }

                            const dt = new Date(dateValueTextConverted);
                            dateValueText = formatDate(dt, 'local:yyyy-MM-dd');
                        }
                    }

                }

                if (dateValueText) {
                    const value: FAM_IDateValue = {
                        type: "date",
                        // value: ExcelDateToJSDate(eachRow[attribute.bcbs_name!]).toISOString()
                        value: dateValueText
                    }
                    return value;
                }

                return null;
            }

        case EControlType.optionset:
            {
                const optionSetId = configAttribute?._bcbs_config_optionsetid_value!;
                const optionSets = config.cache.map_bcbs_config_optionsetitems_bySetId[optionSetId];
                const optionSetItem = optionSets.find(q => q.bcbs_name === valueText || q.bcbs_config_optionsetitemid === valueText || q.bcbs_value?.toString() === valueText);

                if (!optionSetItem)
                    throw new Error(`Default Value for attribute(${configAttribute.bcbs_name}/${configAttribute.bcbs_config_attributeid}) for optionset with text(${valueText}) was not found for ${optionSetId}.`);

                const value: FAM_IEntityReferenceValue = {
                    type: "entity",
                    id: optionSetItem.bcbs_config_optionsetitemid!,
                    entityType: 'bcbs_config_optionsetitem',
                    name: optionSetItem.bcbs_name!,
                }

                return value;

            }

        case EControlType.boolean:
            {
                const trueValue = (valueText === "Yes") || (valueText === "True") || (valueText === "true") || (valueText === "yes");
                const falseValue = (valueText === "No") || (valueText === "False") || (valueText === "false") || (valueText === "no");

                const value: FAM_IBooleanValue = {
                    type: "bool",
                    value: false
                }

                if (trueValue)
                    value.value = true;
                else if (falseValue)
                    value.value = false;
                else
                    throw new Error('expecting to receive Yes/No.');


                return value;
            }

        case EControlType.costshare:
        case EControlType.visionCostshare:
        case EControlType.pharmacyCostshare:
            {
                // cost share really requires scope/category to work, otherwise detecting by category is hard
                const map: Record<number, IXrmTypes_bcbs_config_category> = {
                    [EControlType.visionCostshare]: config.cache.map_bcbs_config_category_named.Vision,
                    [EControlType.pharmacyCostshare]: config.cache.map_bcbs_config_category_named.Pharmacy,
                    [EControlType.costshare]: config.cache.map_bcbs_config_category_named.Medical,
                }


                const costshareCategory = map[control];

                const costShares = config.cache.map_bcbs_copaycoinoption_type[costshareCategory.bcbs_config_categoryid!];

                const costShare = costShares.find(q => q.bcbs_name === valueText || q.bcbs_copaycoinoptionid === valueText);

                if (!costShare)
                    throw new Error('Costshare not found.');

                const value: FAM_IEntityReferenceValue = {
                    type: "entity",
                    entityType: 'bcbs_copaycoinoption',
                    id: costShare.bcbs_copaycoinoptionid,
                    name: costShare.bcbs_name
                }

                return value;

            }

        case EControlType.wholeNumber:
            {
                const value: FAM_INumberValue = {
                    type: "number",
                    value: parseInt(valueText)
                }
                return value;
            }

        case EControlType.decimal:
            {
                const value: FAM_INumberValue = {
                    type: "number",
                    value: parseFloat(valueText)
                }
                return value;
            }

        case EControlType.percent:
            {
                const value: FAM_INumberValue = {
                    type: "number",
                    value: parseInt(valueText)
                }
                return value;
            }
        // todo temp fix, until I find a good solution for this
        case EControlType.lookup:
            {
                if (lookupValue)
                    return lookupValue;

                throw new Error("Lookup has not been implemented.");
            }

        default:
            return null;

    }

}


export interface IFriendlyValueOptions {
    useDecimalFormatterOnCurrency?: boolean;
    useDateFormatter?: boolean;
}

export const friendlyValue = (control: EControlType, value: FAM_TValue, instructions?: IFriendlyValueOptions) => {

    switch (control) {
        case EControlType.text:
            return (value as FAM_IStringValue)?.value ?? "";

        case EControlType.multiText:
            return (value as FAM_IStringValue)?.value ?? "";

        case EControlType.currency:
            if ((value as FAM_INumberValue).value !== null && (value as FAM_INumberValue).value !== undefined) {
                if (instructions?.useDecimalFormatterOnCurrency)
                    return Formatters.ToDecimal((value as FAM_INumberValue).value)
                else
                    return Formatters.ToCurrencyUSD((value as FAM_INumberValue).value)
            }
            return "";

        case EControlType.date:
            if (instructions?.useDateFormatter) {
                const date = (value as FAM_IDateValue).value;
                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`;
            }
            return (value as FAM_IDateValue).value

        case EControlType.optionset:
            return (value as FAM_IEntityReferenceValue).name

        case EControlType.multiOptionset:
            return (value as FAM_IMultiselectOptionSetValue).value

        case EControlType.boolean:
            if ((value as FAM_IBooleanValue).value === true)
                return "Yes";
            if ((value as FAM_IBooleanValue).value === false)
                return "No";
            return "";

        case EControlType.costshare:
            return (value as FAM_IEntityReferenceValue).name;

        case EControlType.visionCostshare:
            return (value as FAM_IEntityReferenceValue).name;

        case EControlType.pharmacyCostshare:
            return (value as FAM_IEntityReferenceValue).name;

        case EControlType.wholeNumber:
            return (value as FAM_INumberValue).value?.toString();

        case EControlType.decimal:
            return (value as FAM_INumberValue).value?.toFixed(2);

        case EControlType.percent:
            return (value as FAM_INumberValue).value?.toString();

        case EControlType.lookup:
            return (value as FAM_IEntityReferenceValue).name;

        case EControlType.message:
            return "Message";

        case EControlType.attributeSet:
            return "AttributeSet";

        default:
            throw new Error("control type mapping was not available");
    }
}


export const friendlyTValue = (value: FAM_TValue) => {

    switch (value?.type) {
        case 'string':
            return (value as FAM_IStringValue)?.value ?? "";

        case 'date':
            return (value as FAM_IDateValue).value

        case 'entity':
            return (value as FAM_IEntityReferenceValue).name

        case 'multioptionset':
            return (value as FAM_IMultiselectOptionSetValue).value

        case 'bool':
            if ((value as FAM_IBooleanValue).value === true)
                return "Yes";
            if ((value as FAM_IBooleanValue).value === false)
                return "No";
            return "";

        case 'number':
            return (value as FAM_INumberValue).value?.toString();

        case 'optionset':
            return value.name;

        default:
            throw new Error("mapping was not available");
    }
}



export function ConvertToDropdownOptions(optionset: FAM_IOptionSetValue[]): IDropdownOption<FAM_IOptionSetValue>[] {
    return optionset.map(eachOption => {
        const t: IDropdownOption<FAM_IOptionSetValue> = {
            key: eachOption.value,
            text: eachOption.name,
            data: eachOption
        };

        return t;
    });
}

export function ConvertToDropdownOption(optionset: FAM_IOptionSetValue): IDropdownOption<FAM_IOptionSetValue> {
    const t: IDropdownOption<FAM_IOptionSetValue> = {
        key: optionset.value,
        text: optionset.name,
        data: optionset
    };

    return t;
}

export interface IApplicationMenuChange {
    items: ICommandBarItemProps[]
}

//TODO Alice I think we may need to simplify this
export enum EViewType {
    ViewOnly = 1,
    Modify = 2,
}

//*********** */
//TODO: ALOT HERE NEEDS TO MOVE TO dataActions, 
//TODO: all global methods should be exposed with state + dispatcher


export const createFeesAndPremiums = (state: RootState): FAM_IFeesAndPremiums => {

    const category = state.data.config.cache.map_bcbs_config_category_named['Fees and Premiums'];
    const fields = createDefaultCategoryFields(state.data.config, category, "Plan", null);

    const newFeesAndPremiums: FAM_IFeesAndPremiums = {
        id: uuidv4(),
        name: `Fees And Premium - New - ${timestamp()}`,
        fields: fields,
        attributeSets: [],
        nonStandards: [],
        stopLossRef: null,
        deactivated: false,
    }

    return newFeesAndPremiums;
}

export const createAccountsReceivable = (
    state: RootState, name?: string
) => {

    const categoryAccountsReceivable = state.data.config.cache.map_bcbs_config_category_named['Accounts Receivable'];
    const fields = createDefaultCategoryFields(state.data.config, categoryAccountsReceivable, "Accounts Receivable", null);

    const t: FAM_IAccountsReceivable = {
        id: uuidv4(),
        name: name ?? `Accounts Receivable - New - ${timestamp()}`,
        fields: fields,
        attributeSets: [],
        nonStandards: [],
        deactivated: false,
    }

    return t;
}

export const createDefaultCategoryFields = (
    release: FAM_IGroupConfigurationConfig,
    category: IXrmTypes_bcbs_config_category,
    name: string,
    tierLevels: FAM_ITierLevel[] | null
) => {
    // const formDef = release.cache.categoryFormDefinitions[category.bcbs_config_categoryid!];
    const generator = new FlexibleFieldGenerator(release);
    const generateFields = generator.generateFieldsForCategoryId(category.bcbs_config_categoryid!, tierLevels);

    return generateFields;
}

export const createAttributeSet = (
    { config, json }: Pick<IGCData, 'config' | 'json'>,
    ownerAttribute: IXrmTypes_bcbs_config_masterattribute
) => {

    const attributes = config.cache.map_bcbs_config_attribute_sets[ownerAttribute!.bcbs_config_masterattributeid!];

    const fields: FAM_IFlexibleField[] = [];

    attributes.forEach(eachAttribute => {
        const fieldSet: FAM_IFlexibleFieldValue[] = [];

        const t: FAM_IFlexibleFieldValue = {
            id: uuidv4(),
            tierRef: null,
            //TODO name? does not make sense here
            type: "primary",
            value: null,
        };

        fieldSet.push(t);

        const field: FAM_IFlexibleField = {
            configRef: { id: eachAttribute.bcbs_config_attributeid!, name: eachAttribute.bcbs_name! },
            id: uuidv4(),
            name: eachAttribute.bcbs_label!,
            masterAttributeID: eachAttribute._bcbs_config_masterattributeid_value!,
            values: fieldSet
        }

        fields.push(field);

    });

    const attributeSet: FAM_IFlexibleFieldSet = {
        name: `${ownerAttribute.bcbs_name} - New - ${timestamp()}`,
        attributeSetRef: {
            id: ownerAttribute.bcbs_config_masterattributeid!,
            name: ownerAttribute.bcbs_name!
        },
        id: uuidv4(),
        fields: fields,
        deactivated: false,
    };

    const scope = BuildVisibilityScope(
        null,
        json,
        null,
        null
    );

    ApplyVisibilityFields(config, attributeSet.fields, scope);

    return attributeSet;
}

/**
 * Clones a passed in benefit
 * @param name 
 * @param benefit 
 * @returns 
 */
export const cloneBenefit = (name: string, benefit: FAM_IBenefit) => {
    const clone: FAM_IBenefit = JSON.parse(JSON.stringify(benefit));

    //TODO: generate id for all cloned field attributes
    clone.name = name;
    clone.id = uuidv4();
    clone.status = {
        "type": "optionset",
        "name": FAM_EBenefitStatus[FAM_EBenefitStatus["In-Progress"]],
        "value": FAM_EBenefitStatus["In-Progress"]
    }

    //TODO: first build attribute model based on category and then try to populate values

    //TODO: add options parameter to allow specifying what needs to be cloned/copied (define clone rules system)

    //TODO: copy tiers
    return clone;
}

export const createPlan = (
    state: RootState,
    name: string | null,
    associatedBenefits: FAM_IBenefit[] | null,
    grandFathered: FAM_IOptionSetValue | null,
    fundingType: FAM_IOptionSetValue | null
) => {

    const category = state.data.config.cache.map_bcbs_config_category[$cat_$plan_id];
    const fields = createDefaultCategoryFields(state.data.config, category, "Plan", null);

    const plan: FAM_IPlan = {
        name: name ?? `Plan - New - ${timestamp()}`,
        id: uuidv4(),
        benefitRefs: [],
        feesAndPremiumsRef: null,
        grandFathered: grandFathered,
        fundingType: fundingType,
        fields: fields,
        attributeSets: [],
        nonStandards: [],
        deactivated: false,
        billingOnlyPlan: false,
    };

    associatedBenefits?.forEach(ben => {
        plan.benefitRefs.push(
            {
                id: ben.id,
                name: ben.name,
            }
        );
    });

    return plan;
}


export const copyClonePlan = (config: FAM_IGroupConfigurationConfig, plans: FAM_IPlan[] | undefined, benefits: FAM_IBenefit[] | undefined) => {

    const planMapping = {} as any;
    const benefitMapping = {} as any;
    const ret = { plans: null as FAM_IPlan[] | null, benefits: null as FAM_IBenefit[] | null }

    const B = benefits?.map(t => {
        const newId = uuidv4();
        benefitMapping[t.id] = newId;

        return {
            ...t,
            id: newId
        } as FAM_IBenefit
    }) ?? [];

    const P = plans?.map(t => {
        const newId = uuidv4();
        planMapping[t.id] = newId;

        t.benefitRefs = t.benefitRefs.reduce(function (result, element) {
            const bId = benefitMapping[element.id];
            if (bId)
                result.push({ ...element, });
            return result;
        }, [] as FAM_IBenefitRef[]);

        return {
            ...t,
            id: newId,
        } as FAM_IPlan
    }) ?? [];

    ret.plans = P;
    ret.benefits = B;

    return ret;
}

export function nonStandardPredicate(props: {
    config?: FAM_IGroupConfigurationConfig,
    section?: IXrmTypes_bcbs_config_section,
    benefit?: FAM_IBenefit,
    groupConfiguration?: FAM_IGroupConfigurationData
}) {
    return (eachAttribute: IXrmTypes_bcbs_config_attribute) => {

        if (!eachAttribute.bcbs_nonstandard)
            return false;

        const _eachAttribute = eachAttribute as ICustomXrmTypes_Ibcbs_config_attribute_extended

        if (_eachAttribute.NonStandardCustomSections && _eachAttribute.NonStandardCustomSections[props.section?.bcbs_config_sectionid!])
            return true;

        return false;
    }
}

export const createNonStandard = (
    data: IGCData,
    scope: {
        section: IXrmTypes_bcbs_config_section,
        benefit?: FAM_IBenefit,
        accountsReceivable?: FAM_IAccountsReceivable,
        feesAndPremium?: FAM_IFeesAndPremiums,
        stopLoss?: FAM_IStopLoss,
        groupConfiguration?: FAM_IGroupConfigurationData,
        templated?: boolean,
        name?: string, //this is for creating new NS related to templates
    }
) => {

    const generator = new FlexibleFieldGenerator(data.config);
    const fields = generator.generateNonStandardFields(scope.section.bcbs_config_sectionid!, scope?.benefit?.tiers);

    const tNew: FAM_INonStandard = {
        id: uuidv4(),
        name: scope.name ?? `Non-Standard - New - ${timestamp()}`,
        sectionRef: {
            id: scope.section.bcbs_config_sectionid!,
            name: scope.section.bcbs_name!
        },
        deactivated: false,
        fields: fields,
        referenceOnly: false,
        partOfTemplate: scope.templated ?? false,
    };
    applyVisibilityNonstandard(data.json, data.config, null, scope.benefit ?? null, tNew);

    return tNew;
}

// const xCache: Record<string, IColumn[]> = {};

/**
 * Creates non-standard columns based on the provided configuration and scope.
 * @param config - The group configuration config.
 * @param scope - The scope containing section, benefit, group configuration, config, and tier names.
 * @param gridConfig - The custom detail list configuration.
 * @param onColumnClick - The callback function for column click event.
 * @param addPredicate - The predicate function to filter fields.
 * @returns An array of extended columns representing the non-standard columns.
 */
export const createNonStandardColumns = (
    config: FAM_IGroupConfigurationConfig,
    scope: {
        section: IXrmTypes_bcbs_config_section,
        benefit?: FAM_IBenefit,
        accountsReceivable?: FAM_IAccountsReceivable,
        feesAndPremium?: FAM_IFeesAndPremiums,
        groupConfiguration?: FAM_IGroupConfigurationData
        tierNames: Record<string, FAM_ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM_IFlexibleField,
        configAttribute?: IXrmTypes_bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes_bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);

    const fields = generator.generateNonStandardFields(scope.section.bcbs_config_sectionid!, scope?.benefit?.tiers)

    const props = scope;
    // const cached = xCache[props?.benefit?.id!];

    // if (cached)
    //     return cached;

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    const tNew: FAM_INonStandard = {
        id: uuidv4(),
        name: '',
        sectionRef: {
            id: scope.section.bcbs_config_sectionid!,
            name: scope.section.bcbs_name!
        },
        deactivated: false,
        fields: fields,
        referenceOnly: false,
    };

    const columns: IExtendedColumn[] = [];

    const addNameColumn = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        var column: IExtendedColumn = {
            key: 'nonStandardName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 300,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    addNameColumn();

    tNew.fields.forEach(eachField => {

        const configAttribute = config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, props.tierNames),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });

    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createGroupStructureColumns = (
    config: FAM_IGroupConfigurationConfig,
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM_IFlexibleField,
        configAttribute?: IXrmTypes_bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes_bcbs_config_masterattribute,
    ) => boolean
) => {

    const columns: IExtendedColumn[] = [];

    // CES Number -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'cesNumber',
            name: 'CES Client Number',
            fieldName: 'cesNumber',
            minWidth: 120,
            isResizable: true,
        };

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    // Group Number -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'groupNumber',
            name: 'Group Number',
            fieldName: 'groupNumber',
            minWidth: 120,
            isResizable: true
        };

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    // Plan -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'plan',
            name: 'Plan',
            fieldName: 'planRef',
            minWidth: 120,
            isResizable: true,
            onRender: onRenderColumnRef,
        };

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }

        columns.push(column);
    }

    // Accounts Receivable -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'accountsReceivable',
            name: 'Accounts Receivable',
            fieldName: 'accountsReceivableRef',
            minWidth: 120,
            isResizable: true,
            onRender: onRenderColumnRef,

        }

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }

        columns.push(column);
    }

    // Stop Loss -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'stopLoss',
            name: 'Stop Loss',
            fieldName: 'stopLossRef',
            minWidth: 120,
            isResizable: true,
            onRender: onRenderColumnRef,
        }

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }

        columns.push(column);
    }

    // Flexible Attributes -------------------------------------
    const generator = new FlexibleFieldGenerator(config);
    const fields = generator.generateGroupNumberFields();
    fields.forEach(eachField => {

        const configAttribute = config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, null),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });

    // Status -------------------------------------
    {
        const column: IExtendedColumn = {
            key: 'status',
            name: 'Status',
            fieldName: 'status',
            minWidth: 120,
            isResizable: true,
        }

        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyName;
            column.filterPredicate = filterPredicateColumnPropertyName;
        }
        columns.push(column);
    }

    return columns.sort((a1, a2) => a1.data?.bcbs_viewsortorder! - a2.data?.bcbs_viewsortorder!);

}

export const createAttributesetColumns = (
    config: FAM_IGroupConfigurationConfig,
    attributeSetId: string,
    scope: {
        tierNames: Record<string, FAM_ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM_IFlexibleField,
        configAttribute?: IXrmTypes_bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes_bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);

    const fields = generator.generateAttributeSetFields(attributeSetId);

    const props = scope;
    // const cached = xCache[props?.benefit?.id!];

    // if (cached)
    //     return cached;

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    const columns: IExtendedColumn[] = [];

    const addNameColumn = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        const column: IExtendedColumn = {
            key: 'attributeSetName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 140,
            data: { bcbs_viewsortorder: Number.MAX_SAFE_INTEGER }
        }

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
    }

    addNameColumn();

    fields.forEach(eachField => {

        const configAttribute = config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, props.tierNames),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });

    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createNonStandardGlobalColumns = (
    config: FAM_IGroupConfigurationConfig,
    scope: {
        nonStandard?: FAM_INonStandard,
        section?: IXrmTypes_bcbs_config_section,
        benefit?: FAM_IBenefit,
        groupConfiguration?: FAM_IGroupConfigurationData
        config: FAM_IGroupConfigurationConfig
        tierNames: Record<string, FAM_ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM_IFlexibleField,
        configAttribute?: IXrmTypes_bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes_bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);

    //const fields = generator.generateNonStandardFields(scope.nonStandard.sectionRef?.id!, scope?.benefit?.tiers)

    const props = scope;
    // const cached = xCache[props?.benefit?.id!];

    // if (cached)
    //     return cached;

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    const tNew: FAM_INonStandard = {
        id: uuidv4(),
        name: '',
        sectionRef: {
            id: scope.nonStandard?.sectionRef?.id! ?? "",
            name: scope.nonStandard?.sectionRef?.name! ?? ""
        },
        deactivated: false,
        fields: [], //fields ?? [],
        referenceOnly: false,
    };

    const columns: IExtendedColumn[] = [];

    const addColumns = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        var column: IExtendedColumn = {
            key: 'nonStandardName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 300,
            data: { bcbs_viewsortorder: 0 },
        };

        var column2: IExtendedColumn = {
            key: 'partOfTemplate',
            name: 'Templated',
            fieldName: 'partOfTemplate',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };

        var column3: IExtendedColumn = {
            key: 'categoryType',
            name: 'Category Type',
            fieldName: 'categoryType',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column4: IExtendedColumn = {
            key: 'categoryName',
            name: 'Category Name',
            fieldName: 'categoryName',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column5: IExtendedColumn = {
            key: 'tab',
            name: 'Tab',
            fieldName: 'tab',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column6: IExtendedColumn = {
            key: 'section',
            name: 'Section',
            fieldName: 'section',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };
        var column7: IExtendedColumn = {
            key: 'benefitDefition',
            name: 'Benefit Definition',
            fieldName: 'benefitDefition',
            isResizable: true,
            minWidth: 200,
            data: { bcbs_viewsortorder: 0 },
        };

        var column9: IExtendedColumn = {
            key: 'payToBenefit',
            name: 'Pay to Benefit',
            fieldName: 'payToBenefit',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column2.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column2, gridConfig);
            column2.sortPredicate = sortPredicateColumnPropertyString;
            column2.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column3.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column3, gridConfig);
            column3.sortPredicate = sortPredicateColumnPropertyString;
            column3.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column4.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column4, gridConfig);
            column4.sortPredicate = sortPredicateColumnPropertyString;
            column4.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column5.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column5, gridConfig);
            column5.sortPredicate = sortPredicateColumnPropertyString;
            column5.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column6.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column6, gridConfig);
            column6.sortPredicate = sortPredicateColumnPropertyString;
            column6.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column7.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column7, gridConfig);
            column7.sortPredicate = sortPredicateColumnPropertyString;
            column7.filterPredicate = filterPredicateColumnPropertyString;
        }
        // Custom Sort Registration
        if (gridConfig) {
            column9.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column9, gridConfig);
            column9.sortPredicate = sortPredicateColumnPropertyString;
            column9.filterPredicate = filterPredicateColumnPropertyString;
        }


        columns.push(column);
        columns.push(column2);
        columns.push(column3);
        columns.push(column4);
        columns.push(column5);
        columns.push(column6);
        columns.push(column7);
        columns.push(column9);

    }

    addColumns();

    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createNonStandardTemplate = (
    data: IGCData,
    scope:
        {
            id: string,
            name: string,
            category: IXrmTypes_bcbs_config_category, //this is for the field values on the template
            linkedCategory: IXrmTypes_bcbs_config_category | null, // this is what category the template is locked to
            //accountsReceivable: FAM.IAccountsReceivable | null,
            //feesAndPremium: FAM.IFeesAndPremiums | null,
            linkedCategoryName: string | null,
            relationships?: FAM_ITemplateRelationship[]
        }
) => {
    // const categoryNonStandards = data.config.cache.map_bcbs_config_category_named['Non-Standard'];
    const generator = new FlexibleFieldGenerator(data.config);
    const fields = generator.generateFieldsForCategoryId(scope.category.bcbs_config_categoryid!);

    //check if we pass in nonstandards for link
    var relationships = [] as FAM_ITemplateRelationship[]; // i believe there is something here that will need attention as to add the non standards to the existing ones already, not to overwrite it.

    if (scope.relationships && scope.relationships.length > 0) {
        relationships = scope.relationships;
    }
    let linkId = '';

    linkId = scope.linkedCategory?.bcbs_config_categoryid!;
    const tNew: FAM_INonStandardTemplate = {
        id: uuidv4(),
        name: scope.name,
        fields: fields,
        linkedCategoryTypeId: linkId ?? undefined,
        linkedCategoryName: scope.linkedCategoryName ?? undefined,
        sectionRef: null,
        deactivated: false,
        relationships: relationships,
    };

    applyVisibilityNonstandardTemplate(data.json, data.config, null, null, tNew);


    return tNew;
}

export const getTemplateFields = (
    data: IGCData,
    scope:
        {
            id: string,
            name: string,
            category: IXrmTypes_bcbs_config_category, //this is for the field values on the template
            linkedCategory: IXrmTypes_bcbs_config_category | null, // this is what category the template is locked to
            linkedCategoryName: string | null,
            relationships?: FAM_ITemplateRelationship[]
        }
) => {
    // const categoryNonStandards = data.config.cache.map_bcbs_config_category_named['Non-Standard'];
    const generator = new FlexibleFieldGenerator(data.config);
    const fields = generator.generateFieldsForCategoryId(scope.category.bcbs_config_categoryid!);


    //check if we pass in nonstandards for link
    var relationships = [] as FAM_ITemplateRelationship[]; // i believe there is something here that will need attention as to add the non standards to the existing ones already, not to overwrite it.

    if (scope.relationships && scope.relationships.length > 0) {
        relationships = scope.relationships;
    }

    const tNew: FAM_INonStandardTemplate = {
        id: uuidv4(),
        name: scope.name,
        fields: fields,
        linkedCategoryTypeId: scope.linkedCategory?.bcbs_config_categoryid ?? undefined,
        linkedCategoryName: scope.linkedCategoryName ?? undefined,
        sectionRef: null,
        deactivated: false,
        relationships: relationships,
    };

    //applyVisibilityNonstandard(data.json, data.config, null, scope.benefit ?? null, tNew);

    return tNew;
}

/**
 * Creates non-standard columns based on the provided configuration and scope.
 * @param config - The group configuration config.
 * @param scope - The scope containing section, benefit, group configuration, config, and tier names.
 * @param gridConfig - The custom detail list configuration.
 * @param onColumnClick - The callback function for column click event.
 * @param addPredicate - The predicate function to filter fields.
 * @returns An array of extended columns representing the non-standard columns.
 */
export const createNonStandardTemplateColumns = (
    config: FAM_IGroupConfigurationConfig,
    scope: {
        category: IXrmTypes_bcbs_config_category
        linkedCategory: IXrmTypes_bcbs_config_category | null,
        //accountsReceivable: FAM.IAccountsReceivable | null,
        //feesAndPremium: FAM.IFeesAndPremiums | null,
        //groupConfiguration?: FAM.IGroupConfigurationData
        config: FAM_IGroupConfigurationConfig
        //tierNames: Record<string, FAM.ITierLevel> | null
    },
    gridConfig?: ICustomDetailListConfiguration,
    onColumnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => void,
    addPredicate?: (
        field?: FAM_IFlexibleField,
        configAttribute?: IXrmTypes_bcbs_config_attribute,
        configMasterAttribute?: IXrmTypes_bcbs_config_masterattribute,
    ) => boolean
) => {

    const generator = new FlexibleFieldGenerator(config);
    const fields = generator.generateFieldsForCategoryId(scope.category.bcbs_config_categoryid!);
    let linkId = '';
    let linkName = '';
    // if (scope.accountsReceivable) {
    //     linkName = scope.accountsReceivable.name;
    //     linkId = scope.accountsReceivable.id!;
    //     //fields = generator.generateFieldsForCategoryId(scope.accountsReceivable.id);
    // }
    // else if (scope.feesAndPremium) {
    //     linkName = scope.feesAndPremium.name;
    //     linkId = scope.feesAndPremium.id!;
    //     //fields = generator.generateFieldsForCategoryId(scope.feesAndPremium.id);
    // }
    // else 

    if (scope.linkedCategory) {
        linkName = scope.linkedCategory.bcbs_name!;
        linkId = scope.linkedCategory.bcbs_config_categoryid!;
        //fields = generator.generateFieldsForCategoryId(scope.linkedCategory.bcbs_config_categoryid!);
    }
    const props = scope;

    const tNew: FAM_INonStandardTemplate = {
        id: uuidv4(),
        name: '',
        linkedCategoryTypeId: linkId ?? undefined,
        linkedCategoryName: linkName ?? undefined,
        sectionRef: null,
        deactivated: false,
        fields: fields,
    };

    const columns: IExtendedColumn[] = [];

    const addNameColumn = () => {

        if (addPredicate)
            if (!addPredicate({ name: 'name' } as any, undefined, undefined))
                return;

        var column: IExtendedColumn = {
            key: 'nonStandardTemplateName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 300,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        var column2: IExtendedColumn = {
            key: 'linkedCategoryName',
            name: 'Benefit Type',
            fieldName: 'linkedCategoryName',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };

        var column3: IExtendedColumn = {
            key: 'sectionNames',
            name: 'Sections',
            fieldName: 'sectionNames',
            isResizable: true,
            minWidth: 100,
            data: { bcbs_viewsortorder: 0 },
        };

        // Custom Sort Registration
        if (gridConfig) {
            column.onColumnClick = onColumnClick;
            UpdateColumnByConfig(column, gridConfig);
            column.sortPredicate = sortPredicateColumnPropertyString;
            column.filterPredicate = filterPredicateColumnPropertyString;
        }

        columns.push(column);
        columns.push(column2);
        columns.push(column3);
    }

    addNameColumn();

    tNew.fields!.forEach(eachField => {

        const configAttribute = props.config.cache.map_bcbs_config_attribute[eachField.configRef.id];
        const configMasterAttribute = props.config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        if (!configAttribute.bcbs_viewsortorder)
            return;

        eachField.values.forEach(eachFieldValue => {

            if (addPredicate)
                if (!addPredicate(eachField, configAttribute, configMasterAttribute))
                    return;

            if (configAttribute.bcbs_config_attributeid === $att_$non_standard_template_$bcbs_nst_effectivedate_id)
                return; //get rid of effective date

            const column: IExtendedColumn = {
                key: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                name: calcFieldName(eachField, eachFieldValue, configAttribute, null),
                minWidth: configAttribute.bcbs_viewcolumnwidth ?? (configAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: `${configAttribute.bcbs_config_attributeid}-${eachFieldValue.tierRef?.id ?? ''}`,
                data: configAttribute,
                onRender: onRenderColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType),
                isResizable: true,
            };

            // Custom Sort Registration
            if (gridConfig) {
                column.onColumnClick = onColumnClick;
                UpdateColumnByConfig(column, gridConfig);
                column.sortPredicate = sortPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
                column.filterPredicate = filterPredicateColumnFAM(configMasterAttribute.bcbs_attributetypecode as EControlType);
            }

            columns.push(column);
        });
    });


    const sorted = columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);

    // xCache[props.benefit?.id!] = sorted;

    return sorted;
}

export const createGroupNumber = (data: IGCData) => {
    const categoryGroupNumber = data.config.cache.map_bcbs_config_category_named['Group Number'];

    let groupNumber: FAM_IGroupNumber = {
        id: uuidv4(),
        cesNumberRef: null,
        prefix: null,
        suffix: null,
        groupNumber: null,
        base: null,
        fields: createDefaultCategoryFields(data.config, categoryGroupNumber, 'Group Structure', []),
        status: data.config.cache.options_benefitStatusReasons.find(q => q.data?.value === FAM_EBenefitStatus['In-Progress'])?.data!,
        deactivated: false,
    };

    // TODO this can be improved since this can be used in bulk
    applyVisibility(data.json, data.config, undefined, { groupNumber: groupNumber });

    return groupNumber;
}

interface ICreateOpportunityProductOptionFromCRM {
    bcbs_opportunitybenefits: IXrmTypes_bcbs_opportunitybenefit[];
    bcbs_opportunityoption: IXrmTypes_bcbs_opportunityoption;
}

/**
 * Creates an opportunity product option benefit based on the provided configuration and CRM data.
 * @param config - The group configuration config object.
 * @param bcbs_quoterequest - The BCBS quote request object from CRM.
 * @param fromCRM - Optional. The data from CRM to initialize the opportunity product option benefit.
 * @param fromState - Optional/ The data from the client app state to initialize the opportunity product option benefit, acting as clone
 * @returns The created opportunity product option benefit.
 */
export const createOpportunityOptionAndBenefits = (
    config: FAM_IGroupConfigurationConfig,
    bcbs_quoterequest?: IXrmTypes_bcbs_quoterequest,
    bcbs_opportunityproduct?: IXrmTypes_bcbs_opportunityproduct,
    fromCRM?: ICreateOpportunityProductOptionFromCRM,
    fromState?: FAM_IOpportunityProductOptionBenefit,
    fromNew?: FAM_ITierDefinition,
) => {

    const convert_bcbs_opportunityoption_to_iopportunityproductoptionbenefit = (
        option: FAM_IOpportunityProductOptionBenefit,
        bcbs_opportunityoption: IXrmTypes_bcbs_opportunityoption
    ) => {

        option.bcbs_opportunityoption = bcbs_opportunityoption;

        option.id = bcbs_opportunityoption?.bcbs_opportunityoptionid!;
        option.name = bcbs_opportunityoption?.bcbs_name!;

        // fields ----
        option.bcbs_buyupuwsinglei = bcbs_opportunityoption?.bcbs_buyupuwsinglei;
        option.bcbs_buyupuwfamilyi = bcbs_opportunityoption?.bcbs_buyupuwfamilyi;
        option.bcbs_buyupuweechildreni = bcbs_opportunityoption?.bcbs_buyupuweechildreni;
        option.bcbs_buyupuweespousei = bcbs_opportunityoption?.bcbs_buyupuweespousei;
        option.bcbs_buyupuwtotali = bcbs_opportunityoption?.bcbs_buyupuwtotali;
        option.bcbs_buyupuwsinglem = bcbs_opportunityoption?.bcbs_buyupuwsinglem;
        option.bcbs_buyupuwfamilym = bcbs_opportunityoption?.bcbs_buyupuwfamilym;
        option.bcbs_buyupuweechildrenm = bcbs_opportunityoption?.bcbs_buyupuweechildrenm;
        option.bcbs_buyupuweespousem = bcbs_opportunityoption?.bcbs_buyupuweespousem;
        option.bcbs_buyupuwtotalm = bcbs_opportunityoption?.bcbs_buyupuwtotalm;
        option.bcbs_annualpremium = bcbs_opportunityoption?.bcbs_annualpremium;

        // Status ----
        option.deactivated = bcbs_opportunityoption?.statuscode === IXrmOptions_bcbs_opportunityoption.statuscode['Inactive(2)'].value
        option.won = bcbs_opportunityoption?.statuscode === IXrmOptions_bcbs_opportunityoption.statuscode['Won(808900001)'].value
        option.bcbs_tierdefinition = JSON.parse(bcbs_opportunityoption?.bcbs_tierdefinition ?? '[]');

        return option
    }

    const opportunityProductCategory = config.cache.map_bcbs_config_category_named['Quote Request'];

    const visibility = bcbs_quoterequest && bcbs_opportunityproduct
        ? VisibilityFromQuoteRequest(bcbs_quoterequest, bcbs_opportunityproduct)
        : VisibilityDefault();

    let option: FAM_IOpportunityProductOptionBenefit = {
        ...opportunityProductCategory,
        id: uuidv4(),
        name: `Option - New - ${timestamp()}`,
        deactivated: false,
        won: false,
        bcbs_tierdefinition: {
            tierSet: null,
            tierLevels: []
        },
        fields: [],
        validationMessages: [],
        visibility: visibility,
        instructions: {}
    };

    option.bcbs_opportunityproduct = bcbs_opportunityproduct;

    // from CRM record?
    if (fromCRM) {
        option.bcbs_tierdefinition = fromCRM.bcbs_opportunityoption.bcbs_tierdefinition
            ? JSON.parse(fromCRM.bcbs_opportunityoption.bcbs_tierdefinition)
            : [];

        // creating fields
        option.fields = createDefaultCategoryFields(
            config,
            opportunityProductCategory,
            'Quote Request',
            option.bcbs_tierdefinition.tierLevels,
        );

        const fieldsMap = ArrayToLookupByPredicate(option.fields, (eachField) => eachField.configRef.id);

        option = convert_bcbs_opportunityoption_to_iopportunityproductoptionbenefit(option, fromCRM.bcbs_opportunityoption);

        option.bcbs_opportunitybenefits = fromCRM.bcbs_opportunitybenefits ?? [];

        // Validation
        if (!option.bcbs_tierdefinition.tierSet) {
            option.requiresUpdate = true;
            option.validationMessages.push({
                title: "Tier Definition is Missing",
                type: EValidationSeverity.error,
                description: "Tier definition is missing, potentially resulting from record not align with the current application's requirements."
            });

            // since we found a problem, we don't want to overwrite benefits
            option.instructions.onSaveOptionBenefitsSkip = true;
        }

        // mapping benefits to fields 
        fromCRM.bcbs_opportunitybenefits?.forEach(eachBenefit => {

            // Validation
            if (eachBenefit._bcbs_config_attributeid_value === null) {
                option.validationMessages.push({
                    description: "The bcbs_config_attributeid is null, potentially resulting from a missing configuration or an unsaved record not migrated to align with the current application's requirements.",
                    title: "Config Attribute ID is Null.",
                    type: EValidationSeverity.error,
                })

                // since we found a problem, we don't want to overwrite benefits
                option.instructions.onSaveOptionSkip = true;
                option.instructions.onSaveOptionBenefitsSkip = true;
                return;
            }

            const field = fieldsMap[eachBenefit._bcbs_config_attributeid_value!];

            if (eachBenefit.bcbs_value) {
                const bcbs_value_object = JSON.parse(eachBenefit.bcbs_value!) as FAM_IFlexibleFieldValue;

                field.values.forEach((eachFieldValue, ix) => {
                    if (eachFieldValue.tierRef?.id !== bcbs_value_object.tierRef?.id)
                        return;

                    if (eachFieldValue.type !== bcbs_value_object.type)
                        return;

                    eachFieldValue.id = eachBenefit.bcbs_opportunitybenefitid ?? bcbs_value_object.id ?? uuidv4();
                    eachFieldValue.emitRefId = bcbs_value_object.emitRefId;
                    eachFieldValue.tierRef = bcbs_value_object.tierRef;
                    eachFieldValue.type = bcbs_value_object.type;
                    eachFieldValue.value = bcbs_value_object.value;
                });
            }
        });

    }
    // from client App ?
    else if (fromState) {
        option.name = fromState.name + ' - Clone';

        // TODO should we reid tiers, probably not
        const tiersByOldId: Record<string, FAM_ITierLevel> = {}

        if (fromState.bcbs_tierdefinition)
            option.bcbs_tierdefinition = jsonClone(fromState.bcbs_tierdefinition);
        else
            option.bcbs_tierdefinition = { tierLevels: [], tierSet: null };

        option.bcbs_tierdefinition.tierLevels.forEach(eachTier => {
            tiersByOldId[eachTier.id] = eachTier;
            eachTier.id = uuidv4();
        })

        // creating fields
        option.fields = createDefaultCategoryFields(
            config,
            opportunityProductCategory,
            'Quote Request',
            option.bcbs_tierdefinition.tierLevels,
        );

        const sourceFieldMap = ArrayToLookupByPredicate(fromState.fields, (eachField) => eachField.configRef.id);

        // Todo
        option.fields.forEach(eachField => {
            const sourceField = sourceFieldMap[eachField.configRef.id];

            eachField.values.forEach(eachFieldValue => {
                sourceField.values.forEach(sourceFieldValue => {
                    if (sourceFieldValue.type !== eachFieldValue.type)
                        return;

                    const newTier = tiersByOldId[sourceFieldValue.tierRef?.id!];
                    if (newTier?.id !== eachFieldValue.tierRef?.id)
                        return;

                    eachFieldValue.value = sourceFieldValue.value;

                })

            })
        })
    } else if (fromNew) {
        // new ?
        option.bcbs_tierdefinition = fromNew;

        // creating fields
        option.fields = createDefaultCategoryFields(
            config,
            opportunityProductCategory,
            'Quote Request',
            option.bcbs_tierdefinition.tierLevels,
        );
    } else {
        throw new Error("Invalid state, must provide either fromCRM, fromState, or fromNew");
    }

    // applying visibility
    ApplyVisibilityFields(config, option.fields, option.visibility);

    return option;
}


export const createGroupStructureDepartment = (config: FAM_IGroupConfigurationConfig) => {
    // todo
}

export const createBenefit = (
    config: FAM_IGroupConfigurationConfig,
    options: {
        category: IXrmTypes_bcbs_config_category,
        fundingType: FAM_IOptionSetValue<number>,
        grandFathered: FAM_IOptionSetValue<number> | null
        tiers?: {
            tiers: FAM_ITierLevel[],
            tierSetRef: FAM_IRef | null,
        }
    },
) => {
    const status = config.cache.options_benefitStatusReasons.find(q => q.data?.value === FAM_EBenefitStatus['In-Progress'])?.data!;

    const benefit: FAM_IBenefit = {
        ...structuredClone(options.category),
        id: uuidv4(),
        name: options.category.bcbs_name ?? "New Benefit",
        tiers: [],
        tierSetRef: null,
        fundingType: null,
        grandFathered: null,
        attributeSets: [],
        nonStandards: [],
        fields: [],
        status: structuredClone(status),
        product: null,
        deactivated: false,
    }

    if (benefit.bcbs_config_categoryid === config.cache.map_bcbs_config_category_named['Pharmacy'].bcbs_config_categoryid)
        benefit.name = "BCBSRX";

    benefit.name = `${benefit.name} - New - ${timestamp()}`;

    if (benefit.bcbs_isfundingtypeenabled) {
        benefit.fundingType = structuredClone(options.fundingType)
    }

    if (options.grandFathered) {
        benefit.grandFathered = structuredClone(options.grandFathered);
    }

    if (options.tiers) {
        benefit.fields = createDefaultCategoryFields(config, benefit, "", options.tiers.tiers);;
        benefit.tiers = structuredClone(options.tiers.tiers);
        benefit.tierSetRef = structuredClone(options.tiers.tierSetRef);
    }

    return benefit;
}

export const createStopLoss = (
    state: RootState, name?: string
) => {
    const categoryStopLoss = state.data.config.cache.map_bcbs_config_category_named['Stop Loss'];
    const fields = createDefaultCategoryFields(state.data.config, categoryStopLoss, "Stop Loss", null);

    const t: FAM_IStopLoss = {
        id: uuidv4(),
        name: name ?? `StopLoss - New - ${timestamp()}`,
        fields: fields,
        attributeSets: [],
        nonStandards: [],
        deactivated: false,
    }

    return t;
}

export interface IFlexibleFieldWithAttributes {
    field: FAM_IFlexibleField;
    configAttribute: IXrmTypes_bcbs_config_attribute;
    masterAttribute: IXrmTypes_bcbs_config_masterattribute;
    section: IXrmTypes_bcbs_config_section;
    tab: IXrmTypes_bcbs_config_tab;
    index: number;
}



/**
 * creates a closure by mapping fields to lookup by master attribute ID, index[0] in the array is the one that should visible and has a value
 * 
 * @param config - The group configuration config.
 * @param fields - The flexible fields.
 * @param action - Optional. The action to perform on each field. *** Maybe invoked multiple times for the same master attribute ID.
 * @returns A map of fields grouped by master attribute ID.
 */
export const FieldsToLookupByMasterAttributeId = (
    config: FAM_IGroupConfigurationConfig,
    fields: FAM_IFlexibleField[],
    action?: (field: IFlexibleFieldWithAttributes[]) => void,
    addConfigAttribute?: boolean,
) => {

    const map = fields.reduce((prev, curr, index) => {

        const configAttribute = config.cache.map_bcbs_config_attribute[curr.configRef.id];

        // TODO temporary safegaurd, remove this after merge revamp fix
        if (!configAttribute)
            return prev;

        const masterAttribute = config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

        const keyMasterAttId = configAttribute._bcbs_config_masterattributeid_value!;
        const keyConfigAttId = configAttribute.bcbs_config_attributeid!;

        const source = prev[keyMasterAttId] ?? [];
        const isHidden = curr?.visibility ?? 0;
        const hasValue = !isHidden && curr?.values?.[0].value?.type;

        const section = config.cache.map_bcbs_config_section[configAttribute._bcbs_config_sectionid_value!];
        const tab = config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value!];

        const instance: IFlexibleFieldWithAttributes = {
            field: curr,
            configAttribute: configAttribute,
            masterAttribute: masterAttribute,
            section: section,
            tab: tab,
            index: index,
        }

        // if invisible push to right
        if (isHidden) {
            source.push(instance);
        } else {
            source.unshift(instance);
        }

        prev[keyMasterAttId] = source;

        // since config attribute is always not the same as master attribute, and is unique, we can add it to the map
        if (addConfigAttribute)
            prev[keyConfigAttId] = [instance];

        action?.(source);

        return prev;
    }, {} as Record<string, IFlexibleFieldWithAttributes[]>);

    return map;
}

export const EntityTierNames = (benefit: FAM_IBenefit) => {
    const tierLookup: Record<string, FAM_ITierLevel> = {};
    benefit.tiers.forEach(tier => {
        const tierName = tier.bcbs_name?.toLowerCase() ?? tier.name;
        tierLookup[tierName] = tier;
    });
}


/**
 * Maps fields to lookup by master attribute ID, first item in the array is the one that is visible and has a value
 * 
 * @param config - The group configuration config.
 * @param fields - The flexible fields.
 * @returns A map of fields grouped by master attribute ID.
 */
export const FieldsToLookupByConfigAttributeId = (config: FAM_IGroupConfigurationConfig, fields: FAM_IFlexibleField[]) => {

    return ArrayToLookupByPredicateWithMap(fields, (eachField) => eachField.configRef.id, (field, index) => {
        const attribute = config.cache.map_bcbs_config_attribute[field.configRef.id];
        const masterAttribute = config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
        const section = config.cache.map_bcbs_config_section[attribute._bcbs_config_sectionid_value!];
        const tab = config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value!];

        const mapped: IFlexibleFieldWithAttributes = {
            field: field,
            configAttribute: attribute,
            masterAttribute: masterAttribute,
            section: section,
            tab: tab,
            index: index ?? 0,
        }

        return mapped;
    });

}


// Event System
// ---------------------------------------------------------
// This is a react anti-pattern, but really good fit for our model due to efficiency
// very simple event system,  and there are really good libraries out there that support wrapping events around command pattern
// but for now this is works, and its pretty simple
export interface ICustomEventDelegate<T> {
    eventType: string;
    details: T,
    handler: (event: CustomEvent<T>) => void;
}

export interface INewGroupConfigurationEvent extends ICustomEventDelegate<FAM_IGroupNumber | null> {
    eventType: 'NewGroupConfiguration',
}

export interface IContextExceptionEvent extends ICustomEventDelegate<unknown | null> {
    eventType: 'globalException',
}

export type TCustomEventTypes = INewGroupConfigurationEvent | IContextExceptionEvent;

export function emitCustomEvent(customEvent: Pick<TCustomEventTypes, 'eventType' | 'details'>) {
    const event = new CustomEvent<any>(customEvent.eventType, {
        detail: customEvent.details
    });

    // lets create a new one is payload is not providing one
    document.dispatchEvent(event);
}

export function subscribeCustomEvent(info: Pick<TCustomEventTypes, 'handler' | 'eventType'>) {
    const handler = info.handler as (event: Event) => void;

    document.addEventListener(info.eventType, handler);
    return () => {
        document.removeEventListener(info.eventType, handler);
    }
}

export function buildBenefitStatusOptions() {

    const options = Object.entries(FAM_EBenefitStatus)
        .filter(([key, value]) => typeof value === 'number')
        .map(([key, value]) => {

            const data: FAM_TBenefitStatusOptionSetValue = {
                //@ts-ignore
                name: key,
                type: 'optionset',
                value: value as FAM_EBenefitStatus
            }
            return data;
        })
        .map(w => {
            const option: IDropdownOption<FAM_TBenefitStatusOptionSetValue> = {
                key: w.value,
                text: w.name,
                data: w
            }
            return option;
        })

    const underWritingOption = options.find(q => q.data?.value === FAM_EBenefitStatus['Underwriting Complete']);

    if (underWritingOption)
        underWritingOption.disabled = true;

    return options;

}

export function buildGroupConfigurationStatusOptions() {

    const options = Object.entries(FAM_EGroupConfigurationStatus)
        .filter(([key, value]) => typeof value === 'number')
        .map(([key, value]) => {

            const data: FAM_TGroupConfigurationStatusOptionSetValue = {
                //@ts-ignore
                name: key,
                type: 'optionset',
                value: value as FAM_EGroupConfigurationStatus
            }
            return data;
        })
        .map(w => {
            const option: IDropdownOption<FAM_TGroupConfigurationStatusOptionSetValue> = {
                key: w.value,
                text: w.name,
                data: w
            }
            return option;
        })

    return options;

}


export function buildProductOptions() {

    const options = Object.entries(FAM_EProduct)
        .filter(([key, value]) => typeof value === 'number')
        .map(([key, value]) => {

            const data: FAM_TProductOptionSetValue = {
                //@ts-ignore
                name: key,
                type: 'optionset',
                value: value as FAM_EProduct
            }
            return data;
        })
        .map(w => {
            const option: IDropdownOption<FAM_TProductOptionSetValue> = {
                key: w.value,
                text: w.name,
                data: w
            }
            return option;
        })

    return options;

}

export function buildDeactivateOptions() {
    const options: IDropdownOption<FAM_TDeactivateOptions>[] = [];
    options.push({ key: 'Inactive', text: 'Inactive', data: { type: 'bool', value: true } })
    options.push({ key: 'active', text: 'Active', data: { type: 'bool', value: false } })
    return options;

}

export const bcbs_config_attributeid_CoverageList = [
    $att_$fees_and_premiums_$bcbs_singlepepmpertier_id, // Employee Only Rate
    $att_$fees_and_premiums_$bcbs_familypepmpertier_id, // Family Rate
    $att_$fees_and_premiums_$bcbs_eechpepmpertier_id, // Employee + Child(ren) Rate
    $att_$fees_and_premiums_$bcbs_eesppepmpertier_id, // Employee + Spouse Rate
    $att_$fees_and_premiums_$bcbs_employeeplusonechildrate_id, // Employee + 1 (Child) Rate
    $att_$fees_and_premiums_$bcbs_tppepmpertier_id, // Two-Person Rate
    $att_$fees_and_premiums_$bcbs_employeeplus2dependentsrate_id, // Employee + 2 Dependents Rate
    $att_$fees_and_premiums_$bcbs_concessionamount_id  // Concession Amount
]


export const bcbs_config_attributeid_FeeList = [
    $att_$fees_and_premiums_$bcbs_singlepepmpertier_id, // Employee Only Rate
    $att_$fees_and_premiums_$bcbs_familypepmpertier_id, // Family Rate
    $att_$fees_and_premiums_$bcbs_eechpepmpertier_id, // Employee + Child(ren) Rate
    $att_$fees_and_premiums_$bcbs_eesppepmpertier_id, // Employee + Spouse Rate
    $att_$fees_and_premiums_$bcbs_employeeplusonechildrate_id, // Employee + 1 (Child) Rate
    $att_$fees_and_premiums_$bcbs_tppepmpertier_id, // Two-Person Rate
    $att_$fees_and_premiums_$bcbs_employeeplus2dependentsrate_id, // Employee + 2 Dependents Rate
    $att_$fees_and_premiums_$bcbs_fee_feeamount_id  // Fee Amount
]

// todo build a model on these data option sets
export const pepmFeeType = {
    "type": "entity",
    "entityType": "bcbs_config_optionsetitem",
    "id": $oset_$fee_fee_type_$per_employee_per_month_pepm_id,
    "name": "Per Employee Per Month (PEPM)"
}

export const pepmPerTierFeeType = {
    "type": "entity",
    "entityType": "bcbs_config_optionsetitem",
    "id": $oset_$fee_fee_type_$pepm_per_tier_id,
    "name": "PEPM per Tier"
}


export const sectionCoverageLevelsAndRates = 'f727d3db-d778-ec11-8d21-000d3a35957e';
export const bcbs_config_attributeid_BillGroup = $att_$fees_and_premiums_$bcbs_billgroupcode_id;
export const bcbs_config_attributeid_BCCAdmin = $att_$fees_and_premiums_$bcbs_bccadminid_id;
export const bcbs_config_attributeid_FeeType = $att_$fees_and_premiums_$bcbs_fee_feetype_id;
export const bcbs_config_attributeid_Guarantee = $att_$fees_and_premiums_$bcbs_guaranteecode_id;
export const bcbs_config_attributeid_ShowSeparateOnBill = $att_$fees_and_premiums_$bcbs_showasseparateitemonbill_id;
export const bcbs_config_attributeid_Onsite = $att_$fees_and_premiums_$bcbs_perscriptonsite_id;
export const bcbs_config_attributeid_BCBSSCOtherSplit = $att_$fees_and_premiums_$bcbs_scothersplit_id;

export const masterAttributeFeeId = $matt_$fees_and_premiums_$bcbs_attributeset_fee_id;

export const bcbs_config_attributeid_Bcbs_StopLossPending = $att_$group_configuration_$bcbs_stoplosspending_id;


export const calcFieldName = (
    field: FAM_IFlexibleField,
    fieldValue: FAM_IFlexibleFieldValue,
    configAttribute: IXrmTypes_bcbs_config_attribute,
    tiers: Record<string, FAM_ITierLevel> | null,
    useTierCustomName: boolean = true,
) => {
    const names: string[] = [];

    if (configAttribute.bcbs_isadvancedoption)
        names.push('💡');

    // if (props.state.data.MNIL?.value)
    //     if (configAttribute.bcbs_ismnil)
    //         names.push('(MNIL)');

    // field name:
    if (configAttribute?.bcbs_label)
        names.push(configAttribute.bcbs_label);

    // tier name : (non-in-network)
    if (tiers && fieldValue.tierRef)
        if (useTierCustomName)
            names.push(tiers[fieldValue.tierRef.id].name);
        else
            names.push(tiers[fieldValue.tierRef.id].bcbs_name!);

    if (fieldValue.type === "pcp")
        names.push("PCP");

    if (fieldValue.type === "specialist")
        names.push("Specialist");

    return names.join(' - ');
}

export const createMultiSelectOptionSetValueFromOptionGuid = (config: FAM_IGroupConfigurationConfig, optionIds: string[]) => {

    var listOfOptions: FAM_IMultiselectOptionSetValueValue[] = [];
    var newMultiSelectOptionSetValue: FAM_IMultiselectOptionSetValue = {
        type: "multioptionset",
        entityType: "bcbs_config_optionsetitem",
        value: "",//listOfNIAValues.join(","),
        options: []
    };

    optionIds.forEach(id => {
        var optionSetItem = config.cache.map_bcbs_config_optionsetitems[id];

        if (optionSetItem !== undefined) {
            var newOption: FAM_IMultiselectOptionSetValueValue =
            {
                id: id,
                name: optionSetItem.bcbs_name as string,
                value: optionSetItem.bcbs_value as number
            };
            listOfOptions.push(newOption);
        }
    })
    //Sort the list of options by name as well
    listOfOptions.sort((a, b) => a.name.localeCompare(b.name));

    newMultiSelectOptionSetValue.options = listOfOptions;

    //set the value to be alphabetical
    newMultiSelectOptionSetValue.value = listOfOptions.map(option => option.name).join(", ");

    return newMultiSelectOptionSetValue;
}

// Benefit Segments : bcbs_config_segmentid = '69d33403-a832-ec11-b6e5-0022480ab88f'
// Ancillary, COBRA, FSA, HRA, HSA, Medical, Pharmacy, Vision, Dental
export const bcbs_config_category_Benefits = [
    $cat_$ancillary_id,
    $cat_$cobra_id,
    $cat_$fsa_id,
    $cat_$hra_id,
    $cat_$hsa_id,
    $cat_$medical_id,
    $cat_$pharmacy_id,
    $cat_$vision_id,
    $cat_$dental_id
];

/**
 * Evaluates which snapshots to pick, when a Group Configuration Snapshot is launched for Underwriting Review.
 * @param snapshot 
 */
// TODO needs to be refactored, asynced, and decoupled from state/redux, renamed to something like MyBestParentSnapshot...
export const compareUnderWritingReviewTo = (state: RootState, snapshot: IXrmTypes_bcbs_groupconfigurationsnapshot) => {
    return async function (dispatch: any) {
        return compareUnderWritingReviewToWithoutDispatch(state, snapshot);
    }
}

// TODO needs to be refactored, asynced, and decoupled from state/redux, renamed to something like MyBestParentSnapshot...
export const compareUnderWritingReviewToWithoutDispatch = (state: RootState, snapshot: IXrmTypes_bcbs_groupconfigurationsnapshot) => {
    if (snapshot?._bcbs_uwconfirmedparentid_value)
        return state.status.snapshots?.find(s => s.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_uwconfirmedparentid_value);

    if (snapshot?.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Benefit Change Continuation(808900007)"].value
        || snapshot?.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Renewal Continuation(808900008)"].value
        || snapshot?.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Initial Setup Continuation(808900005)"].value) {
        const mnilParent = state.status.snapshots?.find(q => q.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshotid_value);
        if (mnilParent?._bcbs_originatingsnapshotid_value && mnilParent._bcbs_originatingsnapshot2id_value) {

            // If there are two Originating Snapshots (Merged record)
            // find the gold standards that have 'Effective Date Gold Standard' set
            // pick the one that matches current configuration effective date

            const test = state.status.snapshots?.find(q =>
                q.bcbs_iseffectivedategoldstandard === true &&
                q.bcbs_effectivedate === mnilParent.bcbs_effectivedate && // this is Date only, I think we should be fine
                q.bcbs_groupconfigurationsnapshotid !== mnilParent.bcbs_groupconfigurationsnapshotid // make sure its not the same one
            );

            return test ?? null;
        }
        else if (mnilParent?._bcbs_originatingsnapshotid_value || mnilParent?._bcbs_originatingsnapshot2id_value) {
            //If there is a single Originating Snapshot (Non-Merged record), compare the snapshot to its Originating Snapshot.

            const originSnapshotId = mnilParent?._bcbs_originatingsnapshotid_value ?? mnilParent?._bcbs_originatingsnapshot2id_value;

            const found = state.status.snapshots?.find(q => q.bcbs_groupconfigurationsnapshotid === originSnapshotId);
            return found ?? null;

        }
        return null;
    }
    if (snapshot?._bcbs_originatingsnapshotid_value && snapshot._bcbs_originatingsnapshot2id_value) {
        let test: IXrmTypes_bcbs_groupconfigurationsnapshot | null = null;
        //Check if only one is UWRC - select that one
        const urwcSnaps = state.status.snapshots?.filter(q =>
            (q.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Underwriting Review Complete(2)'].value ||
                q.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Gold Standard(808900006)'].value ||
                q.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Retired(808900001)'].value) &&
            (q.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshotid_value ||
                q.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshot2id_value)
        );
        if (urwcSnaps?.length === 1) {
            test = urwcSnaps[0];
        }
        //OTHERWISE

        //Do they share a parent - find that parent
        if (test === null) {
            const snap1 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshotid_value);
            const snap2 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshot2id_value);
            let testID: string | null = null;
            if (snap1?._bcbs_originatingsnapshotid_value && (snap1?._bcbs_originatingsnapshotid_value === snap2?._bcbs_originatingsnapshotid_value || snap1?._bcbs_originatingsnapshotid_value === snap2?._bcbs_originatingsnapshot2id_value))
                testID = snap1?._bcbs_originatingsnapshotid_value;
            else if (snap1?._bcbs_originatingsnapshot2id_value && (snap1?._bcbs_originatingsnapshot2id_value === snap2?._bcbs_originatingsnapshotid_value || snap1?._bcbs_originatingsnapshot2id_value === snap2?._bcbs_originatingsnapshot2id_value))
                testID = snap1?._bcbs_originatingsnapshot2id_value;
            if (testID !== null)
                test = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === testID) ?? null;
        }
        //Next, if still none, look at grandparent snapshots. If only one is UWRC, choose it.
        if (test === null) {
            const snap1 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshotid_value);
            const snap2 = state.status.snapshots?.find(b => b.bcbs_groupconfigurationsnapshotid === snapshot?._bcbs_originatingsnapshot2id_value);

            const urwcSnaps = state.status.snapshots?.filter(q =>
                (q.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Underwriting Review Complete(2)'].value ||
                    q.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Gold Standard(808900006)'].value ||
                    q.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Retired(808900001)'].value) &&
                (q.bcbs_groupconfigurationsnapshotid === snap1?._bcbs_originatingsnapshotid_value ||
                    q.bcbs_groupconfigurationsnapshotid === snap1?._bcbs_originatingsnapshot2id_value ||
                    q.bcbs_groupconfigurationsnapshotid === snap2?._bcbs_originatingsnapshotid_value ||
                    q.bcbs_groupconfigurationsnapshotid === snap2?._bcbs_originatingsnapshot2id_value)
            );
            if (urwcSnaps?.length === 1) {
                test = urwcSnaps[0];
            }
        }
        //OTHERWISE
        // If there are two Originating Snapshots (Merged record)
        // find the gold standards that have 'Effective Date Gold Standard' set
        // pick the one that matches current configuration effective date
        // If more than one choose newest;
        if (test === null) {
            test = state.status.snapshots?.filter(q =>
                q.bcbs_iseffectivedategoldstandard === true &&
                q.bcbs_effectivedate === snapshot.bcbs_effectivedate && // this is Date only, I think we should be fine
                q.bcbs_groupconfigurationsnapshotid !== snapshot.bcbs_groupconfigurationsnapshotid // make sure its not the same one
                && q.bcbs_effectivedate !== null
            )?.sort((a, b) => {
                return Date.parse(a.bcbs_effectivedate!) - Date.parse(b.bcbs_effectivedate!);
            })?.[0] ?? null;
        }

        return test ?? null;
    }
    else if (snapshot?._bcbs_originatingsnapshotid_value || snapshot?._bcbs_originatingsnapshot2id_value) {
        //If there is a single Originating Snapshot (Non-Merged record), compare the snapshot to its Originating Snapshot.

        const originSnapshotId = snapshot?._bcbs_originatingsnapshotid_value ?? snapshot._bcbs_originatingsnapshot2id_value;

        const found = state.status.snapshots?.find(q => q.bcbs_groupconfigurationsnapshotid === originSnapshotId);
        return found ?? null;

    }

    return null;
}


interface ILinkOption {
    id: string | null;
    type: "tab"
    | "section"
    | "field"
    | "plan"
    | "benefit"
    | "benefit/tab/section/field"
    | "stopLoss"
    | "accountsReceivable"
    | "claimsAR"
    | "timeline"
    | "feesAndPremium"
    | "checkList"
    | "nonstandardtemplates"
    | "checkListWithPlan"
    | "floridaPrimeRx"
    | "floridaPrimeRxPlan"
    | "capitalPrimeRx"
    | "capitalPrimeRxPlan"
    | "merge"
    | "compare"
    | "underwriting"
    | "complete";
    parent?: ILinkOption;
}
export const AppLinkTo = (
    state: RootState,
    options: ILinkOption,
    ttl = 0
) => {

    let base = `/records/blueRelationship/${state.data.account?.accountid}/groupConfiguration/${state.data.snapshot.bcbs_groupconfigurationsnapshotid}`;

    if (options.parent)
        base = AppLinkTo(state, options.parent, ttl + 1);

    switch (options.type) {
        case "tab":
            return `${base}/tab/${options.id}`;

        case "section":
            return `${base}/section/${options.id}`;

        case "field":
            return `${base}/field/${options.id}`;

        case "plan":
            return `${base}/plan/${options.id}`;

        case "stopLoss":
            return `${base}/stopLoss/${options.id}`;

        case "benefit":
            return `${base}/benefit/${options.id}`;

        case "accountsReceivable":
            return `${base}/claimsAR/${options.id}`;

        case "feesAndPremium":
            return `${base}/feesAndPremium/${options.id}`;

        case "claimsAR":
            return `${base}/claimsAR/${options.id}`;

        case "timeline":
            return `${base}/timeline`;

        case "nonstandardtemplates":
            return `${base}/nonstandardtemplates`;

        case "checkList":
            return `${base}/checklist/list`;

        case "checkListWithPlan":
            return `${base}/checklist/${options.id}`;

        case "floridaPrimeRx":
            return `${base}/prime/florida/`;

        case "floridaPrimeRxPlan":
            return `${base}/prime/florida/plan/${options.id}`;

        case 'capitalPrimeRx':
            return `${base}/prime/capital/`;

        case 'capitalPrimeRxPlan':
            return `${base}/prime/capital/plan/${options.id}`;

        case "merge":
            return `${base}/merge/`;

        case "compare":
            return `${base}/compare/`;

        case "underwriting":
            return `${base}/underwriting/`;

        case 'complete':
            return `${base}/complete/`;

        default:
            return base;
    }
}
export function matchingNonStandard(state: RootState, incomingNonStandard: FAM_INonStandard, incomingTemplate: FAM_INonStandardTemplate, categoryToCheck: FAM_ITemplateRelationship, incomingJson: (FAM_IBenefit | FAM_IAccountsReceivable | FAM_IFeesAndPremiums | FAM_IStopLoss)[]) {
    let returnIds: FAM_TGuid[] = [];
    const templatedNonStandard = structuredClone(incomingNonStandard);
    const template = structuredClone(incomingTemplate);
    const templateFieldMap = ArrayToLookupByPredicate(template.fields, q => q.configRef.id);
    let incomingNSCategoryId = categoryToCheck.categoryID;

    const nonStandardFields = ArrayToLookupByPredicateWithMap(templatedNonStandard!.fields, t => t.configRef.id, t => {
        const attribute = state.data.config.cache.map_bcbs_config_attribute[t.configRef.id];
        const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
        const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
        return {
            field: t,
            attribute,

            masterAttribute,
            controlType,
        }
    });
    const nonStandardDefinition = nonStandardFields[$att_$non_standard_$bcbs_benefitdefinition_id];
    let nonStandardDefinitionValue = "";

    if (nonStandardDefinition.field.values[0].value !== null) {
        nonStandardDefinitionValue = friendlyValue(nonStandardDefinition.controlType, nonStandardDefinition.field.values[0].value);
    }

    let formattedNonStandardDefinition = nonStandardDefinitionValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    //take incoming category id

    //only find section refs of section ref on ns
    categoryToCheck.sectionRefs?.forEach(section => {
        if (section.sectionId === templatedNonStandard.sectionRef?.id) {
            let category: FAM_IBenefit | FAM_IGroupConfigurationData | FAM_IFeesAndPremiums | FAM_IAccountsReceivable | FAM_IStopLoss;

            // --- ID-based match (primary) ---
            // If the template relationship already tracks NS ids for this section, check whether
            // any of those ids still exist on the benefit/GC. When found, return them directly
            // without falling through to the text scan. This prevents a re-apply after a verbiage
            // update from creating a duplicate (the text no longer matches the old template text
            // after the update, so the text scan would falsely return no match).
            if (section.nonStandards && section.nonStandards.length > 0) {
                const trackedIds = new Set(section.nonStandards.map(ns => ns.id));

                const allNonStandards: FAM_INonStandard[] = [];
                if (state.data.json.id === incomingNSCategoryId) {
                    allNonStandards.push(...state.data.json.nonStandards);
                }
                const benefit = incomingJson.find(b => b.id === incomingNSCategoryId);
                if (benefit) {
                    allNonStandards.push(...benefit.nonStandards);
                }

                allNonStandards.forEach(nonStandard => {
                    if (
                        trackedIds.has(nonStandard.id) &&
                        nonStandard.sectionRef?.id === section.sectionId &&
                        nonStandard.deactivated !== true
                    ) {
                        returnIds.push(nonStandard.id);
                    }
                });

                // If we found any id-based match, skip the text scan for this section
                if (returnIds.length > 0) return;
            }

            // --- Text-based match (fallback for first-time apply) ---
            //check group config id
            if (state.data.json.id === incomingNSCategoryId) {
                category = state.data.json;
                //go through each category non standard, make sure section ref is equal to sectionID, then compare
                (category.nonStandards ?? []).forEach(nonStandard => {
                    if (nonStandard.sectionRef?.id === section.sectionId && nonStandard.deactivated !== true) {
                        //we are in the section
                        //get non standard definition
                        const currentNonStandardFieldMap = ArrayToLookupByPredicate(nonStandard.fields, q => q.configRef.id);
                        const currentNonStandardDefinition = currentNonStandardFieldMap[$att_$non_standard_$bcbs_benefitdefinition_id];
                        let currentNonStandardDefinitionValue = friendlyValue(nonStandardDefinition.controlType, currentNonStandardDefinition.values[0].value);
                        let formattedCurrentNonStandardDefinitionValue = currentNonStandardDefinitionValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

                        //compare they are the same
                        if (formattedNonStandardDefinition === formattedCurrentNonStandardDefinitionValue) {
                            //add id to list if they are the same
                            returnIds.push(nonStandard.id);
                        }
                    }
                })
            }
            //check benefitID's
            let benefit = incomingJson.find(benefit => benefit.id === incomingNSCategoryId);
            if (benefit) {
                category = benefit;
                //go through each category non standard, make sure section ref is equal to sectionID, then compare
                (category.nonStandards ?? []).forEach(nonStandard => {
                    if (nonStandard.sectionRef?.id === section.sectionId && nonStandard.deactivated !== true) {
                        //we are in the section
                        //get non standard definition
                        const currentNonStandardFieldMap = ArrayToLookupByPredicate(nonStandard.fields, q => q.configRef.id);
                        const currentNonStandardDefinition = currentNonStandardFieldMap[$att_$non_standard_$bcbs_benefitdefinition_id];
                        let currentNonStandardDefinitionValue = friendlyValue(nonStandardDefinition.controlType, currentNonStandardDefinition.values[0].value);
                        let formattedCurrentNonStandardDefinitionValue = currentNonStandardDefinitionValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
                        //compare they are the same
                        if (formattedNonStandardDefinition === formattedCurrentNonStandardDefinitionValue) {
                            //add id to list if they are the same
                            returnIds.push(nonStandard.id);
                        }
                    }
                })
            }
        }
    })

    return returnIds;
}

export const AppLinkToExternal = (
    options: {
        id: string | string[],
        type: "systemuser"
        | "account"
        | "opportunity"
        | "bcbs_quoterequest"
        | "bcbs_groupconfigurationsnapshot"
        | "bcbs_config_attribute"
        | "bcbs_config_masterattribute"
        | "bcbs_sbc"
        | "bcbs_bncreport"
        | "bcbs_schedulea"
        | "bcbs_carrier"
        | "customEntityType"
        | "groupLibrary"
        | "groupLibrary:bcbs_opportunityproduct"
        | 'bcbs_grouplibraryprocess'
        | 'bcbs_config_release'
        | 'task'
        | 'bcbs_config_optionsetitem',
        logicalName?: string;
        extraQS?: any;
    }
) => {

    let extraQSStr = '';

    if (options.extraQS)
        for (var key in options.extraQS) {
            extraQSStr += `&${key}=${options.extraQS[key]}`;
        }

    if (extraQSStr)
        extraQSStr = "&extraqs=" + encodeURIComponent(extraQSStr.substring(1));

    switch (options.type) {
        case "systemuser":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=systemuser&id=${options.id}`;

        case "account":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=account&id=${options.id}`;

        case "opportunity":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${options.id}`;

        case "bcbs_quoterequest":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_quoterequest&id=${options.id}`;

        case "bcbs_groupconfigurationsnapshot":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_groupconfigurationsnapshot&id=${options.id}`;

        case "bcbs_config_attribute":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=${options.id}`;

        case "bcbs_config_masterattribute":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=${options.id}`;

        case "bcbs_sbc":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_sbc&id=${options.id}`;

        case "bcbs_bncreport":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_bncreport&id=${options.id}`;

        case "bcbs_schedulea":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_schedulea&id=${options.id}`;

        case "customEntityType":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=${options.logicalName}${extraQSStr}`;

        case "bcbs_carrier":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_carrier&id=${options.id}`;

        case "groupLibrary":
            return `${Constants.app.groupLibraryURL}/editor/records/blueRelationship/${options.id[0]}/groupConfiguration/${options.id[1]}${options.id[2] ? "-v" + BlobVersionToURIVersion(options.id[2]) : ""}`;

        case "groupLibrary:bcbs_opportunityproduct":
            return `${Constants.app.groupLibraryURL}/editor/bcbs_opportunityproduct/${options.id}`;

        case "bcbs_grouplibraryprocess":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_grouplibraryprocess&id=${options.id}`;

        case "task":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=task&id=${options.id}`;

        case "bcbs_config_release":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_release&id=${options.id}`;

        case "bcbs_config_optionsetitem":
            return `${Constants.crm.baseUrl}/main.aspx?appid=${Constants.app.crmAppId}&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=${options.id}`;

        default:
            throw new Error("Unknown type for AppLinkToExternal");
            break;
    }
}

export const BlobVersionToURIVersion = (string: string) => {
    return encodeURIComponent(string.replace(".", 'dot'));
}

export const URIVersionToBlobVersion = (string: string) => {
    return decodeURIComponent(string.replace("dot", '.'));
}


export enum ENavigationReason {
    COMPARE_APP = "compareApp",
    CRM_ACCOUNT = "crm-account",
    FINISHED = "finished",
}

/**
 * Navigation gateway to makes a decision about state/store management and type of redirect
 * in case of internal redirect, it it used to force history reinstating
 * - Every internal navigation should run through this method
 * @param history 
 * @param state 
 * @param reason 
 */
export const AppNavigateToExternal = (history: any, state: RootState, reason: ENavigationReason) => {
    switch (reason) {
        case ENavigationReason.CRM_ACCOUNT:
            const url = AppLinkToExternal({ type: 'account', id: state.status.account?.accountid! });
            if (url)
                (window as Window).location = url;
            break;

        case ENavigationReason.COMPARE_APP:
            const foundSnapshot = compareUnderWritingReviewToWithoutDispatch(state, state.data.snapshot);
            (window as Window).location = (`/comparison/${state.data.account?.accountid}/${foundSnapshot?.bcbs_groupconfigurationsnapshotid ? `${foundSnapshot?.bcbs_groupconfigurationsnapshotid}/` : ""}${state.data.snapshot.bcbs_groupconfigurationsnapshotid}/`);
            break;

        // TODO RETIRE THIS,
        // use history push
        case ENavigationReason.FINISHED:
            history.push('/finished');
            break;

        default:
            break;
    }

}

export const createTierLevelFactory = (
    XRMTierSet: IXrmTypes_bcbs_config_tierset,
    XRMTierLevel: IXrmTypes_bcbs_config_tierlevel,
    fromTierLevel?: FAM_ITierLevel,
    options?: {
        keep_bcbs_name?: boolean
    }
) => {

    if (!XRMTierSet && !XRMTierLevel)
        throw new Error("TierSet and TierLevel are required");

    const tierSets = ["3 Tier EPO", "3 Tier PPO", "4 Tier", "5 Tier", "6 Tier"];

    const is3Tier = tierSets.includes(XRMTierSet.bcbs_name!);
    const isTier1To4 = Tier1To4.includes(XRMTierLevel.bcbs_name!);

    const t: FAM_ITierLevel = {
        ...XRMTierLevel,
        id: fromTierLevel?.id ?? uuidv4(),
        name: fromTierLevel?.name ?? (!isTier1To4 ? XRMTierLevel.bcbs_name : '') ?? '',
        description: fromTierLevel?.description ?? XRMTierLevel.bcbs_name ?? '',
        pcp: fromTierLevel?.pcp ?? false,
        ion: fromTierLevel?.ion ?? XRMTierLevel.bcbs_name === 'Out of Network',
        isLabelDisabled: (XRMTierLevel.bcbs_name === 'In Network' || XRMTierLevel.bcbs_name === 'Out of Network') && !is3Tier,
    };

    if (options?.keep_bcbs_name)
        if (!t.name)
            t.name = XRMTierLevel.bcbs_name!;

    return t;

}

export const createTierLevels = (
    config: FAM_IGroupConfigurationConfig,
    bcbs_config_tiersetid: string,
) => {
    const tierSet = config.tiersets.find(q => q.bcbs_config_tiersetid === bcbs_config_tiersetid)!;
    const tierLevels = config.cache.map_bcbs_config_tierlevels_by_tierSetId[tierSet.bcbs_config_tiersetid!]


    const tiers = tierLevels?.map((eachTier, index) => {
        return createTierLevelFactory(
            tierSet,
            eachTier,
            undefined,
            {
                keep_bcbs_name: true
            },
        );
    });


    return { tierSet, tierLevels, tiers };

}


export const Tier1To4 = ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4'];


export function reconcileTiers(oldTiers: FAM_ITierLevel[], newTiers: FAM_ITierLevel[], inheritTierIdsFromOldTiers = true) {
    const swp: FAM_ITierLevel[] = [];

    const tChangeList: ITierLevelChange[] = [];
    oldTiers?.forEach(oldTier => {
        const t: ITierLevelChange = {
            isDelete: false,
            tier: oldTier,
            oldTier: oldTier,
        };
        tChangeList.push(t);

        if (Tier1To4.includes(oldTier.bcbs_name!)) {
            swp.push(oldTier);
        }

    });

    newTiers.forEach(newTier => {
        const tChange = tChangeList.find(q => q.tier.bcbs_name === newTier.bcbs_name);

        if (tChange) {

            tChange.newTier = newTier;
            tChange.tier = newTier;

            if (Tier1To4.includes(newTier.bcbs_name!)) {
                tChange.oldTierOptions = swp;
            }

        } else {
            const t: ITierLevelChange = {
                isDelete: false,
                isNew: true,
                tier: newTier,
                newTier: newTier,
            };

            tChangeList.push(t);
        }

    });

    // data sync between tiers
    // ------------------------
    tChangeList.forEach(eChange => {

        if (!eChange.newTier)
            eChange.isDelete = true;

        // if successfully mapped, try using same tier ids
        if (inheritTierIdsFromOldTiers)
            if (eChange.oldTier && eChange.newTier)
                eChange.newTier.id = eChange.oldTier?.id;
    });

    // Comprehensive - In Network mapping
    // ------------------------
    const oldComprehensive = tChangeList.find(q => q.oldTier?.bcbs_name === 'Comprehensive');
    const newComprehensive = tChangeList.find(q => q.newTier?.bcbs_name === 'Comprehensive');
    const oldInNetwork = tChangeList.find(q => q.oldTier?.bcbs_name === 'In Network');
    const newInNetwork = tChangeList.find(q => q.newTier?.bcbs_name === 'In Network');

    if (newComprehensive && oldInNetwork) {
        newComprehensive.oldTier = oldInNetwork.oldTier;
        // oldInNetwork.newTier = newComprehensive.newTier;
    }

    if (oldComprehensive && newInNetwork) {
        newInNetwork.oldTier = oldComprehensive.oldTier;
    }


    // ------------------------
    const mapSorted = tChangeList.sort((a, b) => (a?.tier?.bcbs_sortorder ?? 0) - (b?.tier?.bcbs_sortorder ?? 0));
    return mapSorted;
}

export const reconcileFields = (
    newFields: FAM_IFlexibleField[],
    oldFields: FAM_IFlexibleField[],
    tierChange: ITierChange,
    config: FAM_IGroupConfigurationConfig
) => {


    // * try to use same field id
    // value id also good to copy (include id, and everything)
    // Scenarios:
    // - Not Tiered -> 
    // - Comprehensive -> Comprehensive
    // - Comprehensive -> InNtw/OutNtw
    // - Comprehensive -> InNtw/OutNtw + Tiers
    // - InNtw/OutNtw -> Comprehensive
    // - InNtw/OutNtw + Tiers -> Comprehensive
    // - InNtw/OutNtw -> Comprehensive
    // - X -> X
    // configId > Field
    const oldFieldsLookup: Record<string, FAM_IFlexibleField> = {};
    oldFields.forEach(t => {
        oldFieldsLookup[t.configRef.id] = t;
    });

    newFields.forEach(newField => {
        const oldField = oldFieldsLookup[newField.configRef.id];

        if (oldField && oldField.values && oldField.values.length > 0) {
            // if field is not tiered:
            // * new value should also not be tiered
            // * copy as is
            // we dont care about pcp/specialist
            if (!oldField.values[0].tierRef) {
                newField.values = oldField.values;
                return;
            }

            // if field is tiered:
            newField.values.forEach(newValue => {

                const map = tierChange.tierChanges.find(q => q.newTier?.id === newValue.tierRef?.id);
                if (map) {

                    // ok we are deleting this, so ignore ...
                    if (map.isDelete)
                        return;

                    // field has been mapped
                    if (map.oldTier?.id && map.newTier?.id) {

                        // TODO PCP/Specialist
                        // scenarios:
                        // 1) Primary <- PCP+Specialist
                        // map Primary from PCP
                        // 2) PCP+Specialist <- Primary
                        // - map PCP from primary
                        // 3) PCP+Specialist -> PCP+Specialist
                        // - map PCP from PCP and Specialist from Specialist
                        if (newValue.type === 'pcp') {

                            const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'pcp');

                            if (oldFieldValue) {
                                newValue.value = oldFieldValue.value;
                            } else {
                                const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'primary');

                                if (oldFieldValue)
                                    newValue.value = oldFieldValue.value;
                            }
                        }
                        else if (newValue.type === 'specialist') {

                            const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'specialist');

                            if (oldFieldValue)
                                newValue.value = oldFieldValue.value;

                        }
                        else if (newValue.type === 'primary') {

                            const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'primary');

                            if (oldFieldValue) {
                                newValue.value = oldFieldValue.value;
                            }
                            else {

                                const oldFieldValue = oldField.values.find(q => q.tierRef?.id === map.oldTier!.id && q.type === 'pcp');

                                if (oldFieldValue)
                                    newValue.value = oldFieldValue.value;

                            }
                        }

                    }

                }
            });

        }

    });

    return {
        fields: newFields,
        tierSet: tierChange.tierSet,
    };
}

export const reconcileBenefit = (
    benefit: FAM_IBenefit,
    tierChange: ITierChange,
    config: FAM_IGroupConfigurationConfig,
    allowLevelChange = true
) => {


    const _tiers: FAM_ITierLevel[] = [];

    // lets grab good tiers from requested change
    tierChange.tierChanges.forEach(t => {

        // if (t.isDelete)
        //     if (allowLevelChange)
        //         return;

        // if (t.isNew)
        //     if (!allowLevelChange)
        //         return;

        if (t.isDelete)
            return;

        _tiers.push(t.tier);
    });

    const benefitCategory = config.cache.map_bcbs_config_category[benefit.bcbs_config_categoryid!];
    const _fields = createDefaultCategoryFields(config,
        benefitCategory,
        benefit.name,
        _tiers
    );

    const changes = reconcileFields(
        _fields,
        benefit.fields,
        tierChange,
        config
    );

    // const categoryNonStandards = config.cache.map_bcbs_config_category_named['Non-Standard'];

    benefit.nonStandards.forEach(eachNS => {

        const generator = new FlexibleFieldGenerator(config);
        const _fields = generator.generateNonStandardFields(eachNS.sectionRef?.id!, _tiers)

        reconcileFields(
            _fields,
            eachNS.fields,
            tierChange,
            config
        );

        eachNS.fields = _fields;

    });

    benefit.fields = changes.fields;
    benefit.tiers = _tiers;
    benefit.tierSetRef = {
        id: changes.tierSet?.bcbs_config_tiersetid!,
        name: changes.tierSet?.bcbs_name!,
    }
}


export const suggestNewCESNumber = (cesNumbers: FAM_ICESNumber[]) => {

    let lastDigit = 1;

    if (cesNumbers.length > 0)
        lastDigit = cesNumbers.reduce((prev, curr) => {
            const parsedPlaceHolder = curr.cesNumber?.match(/(?:<Place Holder\s)(\d+)>/);

            if (parsedPlaceHolder?.length === 2) {
                const placeHolderDigit = parseInt(parsedPlaceHolder[1]) + 1;

                if (placeHolderDigit > prev)
                    return placeHolderDigit;
            }
            return prev;
        }, 1);

    const data: FAM_ICESNumber = {
        id: uuidv4(),
        cesNumber: `<Place Holder ${lastDigit}>`,
        deactivated: false,
    };

    return data;
}


export interface ICancellationFieldItems {
    "CategoryName": string;
    "Run Out Claims End Date": string;
    "Pay Run Out Claims How Many Months": string;
    "Cancellation Effective Date": string;
}
export interface ICancellationFields {
    [key: string]: ICancellationFieldItems;
}

export const CancellationFieldsByCategory: ICancellationFields = {

    [$cat_$group_configuration_id]: {
        "CategoryName": "Group Configuration",
        "Run Out Claims End Date": $att_$group_configuration_$bcbs_runoutclaimsenddate_id,
        "Pay Run Out Claims How Many Months": $att_$group_configuration_$bcbs_payrunoutclaimshowmanymonths_id,
        "Cancellation Effective Date": $att_$group_configuration_$bcbs_cancellationeffectivedate_id
    },
    [$cat_$group_number_id]: {
        "CategoryName": "Group Number",
        "Run Out Claims End Date": $att_$group_number_$bcbs_runoutclaimsenddate_id,
        "Pay Run Out Claims How Many Months": $att_$group_number_$bcbs_payrunoutclaimshowmanymonths_id,
        "Cancellation Effective Date": $att_$group_number_$bcbs_cancellationeffectivedate_id
    },
    [$cat_$medical_id]: {
        "CategoryName": "Medical",
        "Cancellation Effective Date": $att_$medical_$bcbs_cancellationeffectivedate_id,
        "Pay Run Out Claims How Many Months": $att_$medical_$bcbs_payrunoutclaimsmonths_id,
        "Run Out Claims End Date": $att_$medical_$bcbs_runoutclaimsenddate_id
    },
    [$cat_$dental_id]: {
        "CategoryName": "Dental",
        "Cancellation Effective Date": $att_$dental_$bcbs_cancellationeffectivedate_id,
        "Pay Run Out Claims How Many Months": $att_$dental_$bcbs_payrunoutclaimsmonths_id,
        "Run Out Claims End Date": $att_$dental_$bcbs_runoutclaimsenddate_id
    },
    [$cat_$vision_id]: {
        "CategoryName": "Vision",
        "Cancellation Effective Date": $att_$vision_$bcbs_cancellationeffectivedate_id,
        "Pay Run Out Claims How Many Months": $att_$vision_$bcbs_payrunoutclaimsmonths_id,
        "Run Out Claims End Date": $att_$vision_$bcbs_runoutclaimsenddate_id
    },
    [$cat_$pharmacy_id]: {
        "CategoryName": "Pharmacy",
        "Cancellation Effective Date": $att_$pharmacy_$bcbs_cancellationeffectivedate_id,
        "Pay Run Out Claims How Many Months": $att_$pharmacy_$bcbs_payrunoutclaimsmonths_id,
        "Run Out Claims End Date": $att_$pharmacy_$bcbs_runoutclaimsenddate_id
    },
    [$cat_$cobra_id]: {
        "CategoryName": "COBRA",
        "Cancellation Effective Date": $att_$cobra_$bcbs_cancellationeffectivedate_id,
        'Pay Run Out Claims How Many Months': '',
        "Run Out Claims End Date": ''
    },
    [$cat_$hra_id]: {
        "CategoryName": "HRA",
        "Cancellation Effective Date": $att_$hra_$bcbs_hracancellationeffectivedate_id,
        "Run Out Claims End Date": $att_$hra_$bcbs_hrarunoutclaimsenddate_id,
        "Pay Run Out Claims How Many Months": $att_$hra_$bcbs_hrapayrunoutclaimshowmanymonths_id,
    },
    // "a7605d43-d63c-ec11-b6e5-0022480a9561": {
    //     "CategoryName": "FSA",
    //     "Run Out Claims End Date": '7ffbb77c-578d-ec11-b400-0022480a90e0',
    //     "Cancellation Effective Date": '6ffbb77c-578d-ec11-b400-0022480a90e0',
    //     "Pay Run Out Claims How Many Months": '9632a33f-548d-ec11-b400-0022480a90e0',
    // }
    // "9d86ede9-2a53-ee11-be6f-000d3a305861": {
    //     "CategoryName": "LSA",
    //     "Cancellation Effective Date": 'cf8d55bd-d253-ee11-be6f-000d3a305861',
    //     "Pay Run Out Claims How Many Months": '',
    //     "Run Out Claims End Date": ''
    // }


}

export function isBaseAdminQuoteTypeCode(bcbs_quotetypecode?: number) {
    const useBaseAdmin =
        bcbs_quotetypecode === IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['Administrative Services Only(808900000)'].value ||
        bcbs_quotetypecode === IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['ASO with Stop Loss(808900001)'].value ||
        bcbs_quotetypecode === IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['National Alliance(808900003)'].value

    return useBaseAdmin;
}

export async function DetailListExcelGenerationAsync(
    dispatch: Dispatch<any>,
    state: RootState,
    application: IApplicationContext,
    columns: IColumn[],
    items: any[]
) {
    console.table(items);
    console.table(columns);
    try {
        dispatch(setProcessing(true));
        const excelExtractImport = await import("global/ExcelExtract")
        const { DetailListExcelGeneration } = excelExtractImport;
        const result = await DetailListExcelGeneration(
            state,
            application.dataSource,
            columns as any,
            items,
        )
        const fileName = `Extract-${new Date().getTime()}.xlsx`;
        saveAs(result.file, fileName);
    } catch (error) {
        emitCustomEvent({
            eventType: 'globalException',
            details: error
        });
    } finally {
        dispatch(setProcessing(false));
    }
}

export const VisibilityDefault = () => {
    const visibility: IVisibilityScope = {
        effectiveDate: 0,
        operativeDate: 0,
        erisa: null,
        fundingType: null,
        grandFathered: null,
        lineOfBusiness: null,
        product: false,
        cancelled: false,
    };

    return visibility;
}

export const VisibilityFromQuoteRequest = (
    bcbs_quoterequest: IXrmTypes_bcbs_quoterequest,
    bcbs_opportunityproduct: IXrmTypes_bcbs_opportunityproduct,
) => {
    const visibility = VisibilityDefault();

    if (bcbs_opportunityproduct && bcbs_opportunityproduct.bcbs_quotetypecode) {
        const map: Record<number, number> = {}

        map[IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['ASO with Stop Loss(808900001)'].value] = IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['ASO with Stop Loss(808900001)'].value;
        map[IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['Administrative Services Only(808900000)'].value] = IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['Administrative Services Only(808900000)'].value;
        map[IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['Fully Insured(808900002)'].value] = IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['Fully Insured(808900002)'].value;
        map[IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['Level Funded(808900004)'].value] = IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['Level Funded(808900004)'].value;
        map[IXrmOptions_bcbs_opportunityproduct.bcbs_quotetypecode['National Alliance(808900003)'].value] = IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_fundingtypecode['National Alliance(808900003)'].value;

        visibility.fundingType = map[bcbs_opportunityproduct.bcbs_quotetypecode] ?? null;
    }

    if (bcbs_quoterequest?.bcbs_effectivedate)
        visibility.effectiveDate = new Date(bcbs_quoterequest.bcbs_effectivedate).getTime();

    if (bcbs_quoterequest?.createdon)
        visibility.operativeDate = new Date(bcbs_quoterequest.createdon).getTime();

    return visibility;
}

export function CreateSnapshotFromOption(state: RootState, optionBenefit: FAM_IOpportunityProductOptionBenefit) {
    const snapshot = blankSnapshot()
    return snapshot;
}


export const getSnapshotRef = (snapshot: IXrmTypes_bcbs_groupconfigurationsnapshot) => {
    const snapshotRef: FAM_IEntityReferenceValue = {
        entityType: 'bcbs_groupconfigurationsnapshot',
        type: 'entity',
        id: snapshot.bcbs_groupconfigurationsnapshotid!,
        name: snapshot.bcbs_name!
    };

    return snapshotRef;
}

export const getAccountRef = (account: IXrmTypes_account) => {

    const accountRef: FAM_IEntityReferenceValue = {
        entityType: 'account',
        type: 'entity',
        id: account?.accountid!,
        name: account?.name!
    }

    return accountRef;
}


export const getExactValue = <T extends FAM_TValue>(
    attributeLookup: Record<string, IFlexibleFieldWithAttributes[]>,
    attributeId: string,
    tierLookup: Record<string, FAM_ITierLevel> | null,
    tierName: FAM_TTierLevels | null,
    typeName: FAM_TFieldType | null,
) => {

    const att = attributeLookup[attributeId];

    const values = att?.[0].field.values.filter(t => {
        if (tierName && tierLookup) {
            const tier = tierLookup[tierName];

            if (!tier)
                return false;

            if (t.tierRef?.id !== tier.id)
                return false;
        }

        if (typeName && t.type !== typeName)
            return false;

        return true;
    });

    if (values && values.length === 1)
        return values[0].value as T;
    else {
        console.error("getExactValue", attributeLookup, tierName, typeName);
    }

    return null;
}

export const getBestValue = <T extends FAM_TValue>(
    attributeLookup: Record<string, IFlexibleFieldWithAttributes[]>,
    attributeId: string,
    tierLookup: Record<string, FAM_ITierLevel> | null,
    tierName: FAM_TTierLevels[] | null, // by order of interest
    typeName: FAM_TFieldType[] | null, // by order of interest
) => {
    throw new Error("Not implemented");
}

export const getExactFriendlyValue = (
    attributeLookup: Record<string, IFlexibleFieldWithAttributes[]>,
    attributeId: string,
    tierLookup: Record<string, FAM_ITierLevel> | null,
    tierName: FAM_TTierLevels | null,
    typeName: FAM_TFieldType | null,
) => {
    const val = getExactValue<FAM_TValue>(attributeLookup, attributeId, tierLookup, tierName, typeName);
    return val ? friendlyTValue(val) : null;
}

export const getTiersByBCBSName = (benefit: FAM_IBenefit, config: FAM_IGroupConfigurationConfig): Record<string, FAM_ITierLevel> => {
    const tiers: Record<string, FAM_ITierLevel> = {};

    benefit.tiers.forEach(t => {
        tiers[t.bcbs_name!] = t;
    });

    return tiers;
}

export const setExactValue = (
    config: FAM_IGroupConfigurationConfig,
    attributeLookup: Record<string, IFlexibleFieldWithAttributes[]>,
    attributeId: string,
    tierLookup: Record<string, FAM_ITierLevel> | null,
    tierName: FAM_TTierLevels | null,
    typeName: FAM_TFieldType | null,
    newValue: FAM_TValue | string,
) => {

    if (tierName)
        throw new Error("Not implemented");

    if (typeName)
        throw new Error("Not implemented");

    const att = attributeLookup[attributeId];

    const fieldDefinition = att?.[0]

    if (!fieldDefinition)
        throw new Error("Not found");

    // make sure its shown
    delete fieldDefinition.field.visibility;

    const field = fieldDefinition.field.values[0];

    if (typeof newValue === 'string') {

        field.value = friendlyValueToFlexibleFieldValue(
            config,
            newValue,
            fieldDefinition.configAttribute,
            fieldDefinition.masterAttribute,
            null
        );

    } else {

        field.value = newValue;
    }
}


// Cancellation Fields ---------------------------------
// CategoryName: Group Number
export const CalculateRunOutClaimsEndDate = (
    json: IGroupConfigurationData,
    cancellationFields: ICancellationFieldItems,
    field: FAM_IFlexibleField,
    fieldMap: Map<string, IFieldReference>,
    onUpdate: (calculatedValue: FAM_TValue, fieldAttribute: FAM_IFlexibleField, fieldValue: FAM_IFlexibleFieldValue) => void,
) => {

    const {
        "Cancellation Effective Date": cancellationEffectiveDateId,
        "Pay Run Out Claims How Many Months": payRunOutClaimsHowManyMonthsId,
        "Run Out Claims End Date": runOutClaimsEndDateId,
    } = cancellationFields ?? {};

    // Auto-calculate Run Out Claims End Date
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/377166
    // Benefit Level
    if (field.configRef.id === cancellationEffectiveDateId || field.configRef.id === payRunOutClaimsHowManyMonthsId) {

        // Cancellation Effective Date
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=c9a8fddf-52a3-ec11-9840-0022480b1a5e
        let bcbs_cancellationeffectivedate = null as null | string;
        const bcbs_cancellationeffectivedate_fieldMap = fieldMap.get(cancellationEffectiveDateId);
        if (bcbs_cancellationeffectivedate_fieldMap?.field.values?.[0].value?.type === 'date')
            bcbs_cancellationeffectivedate = bcbs_cancellationeffectivedate_fieldMap.field.values[0].value.value;

        // Group Configuration: if this is root, use effective date configuration
        if (cancellationEffectiveDateId === $att_$group_configuration_$bcbs_cancellationeffectivedate_id)
            bcbs_cancellationeffectivedate = json.effectiveDate?.value!;

        // Pay Run Out Claims How Many Months
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=cda8fddf-52a3-ec11-9840-0022480b1a5e
        const bcbs_payrunoutclaimsmonths_fieldMap = fieldMap.get(payRunOutClaimsHowManyMonthsId);
        let bcbs_payrunoutclaimsmonths = null as null | number;
        if (bcbs_payrunoutclaimsmonths_fieldMap?.field.values?.[0].value?.type === 'number')
            bcbs_payrunoutclaimsmonths = bcbs_payrunoutclaimsmonths_fieldMap?.field.values[0].value.value;

        // Run Out Claims End Date
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=cfa8fddf-52a3-ec11-9840-0022480b1a5e
        const bcbs_runoutclaimsenddate_fieldMap = fieldMap.get(runOutClaimsEndDateId);

        if (bcbs_cancellationeffectivedate && bcbs_payrunoutclaimsmonths && bcbs_runoutclaimsenddate_fieldMap) {
            const dateAPlusNMonths = addNMonthsToDateString(bcbs_cancellationeffectivedate, bcbs_payrunoutclaimsmonths);
            const field = bcbs_runoutclaimsenddate_fieldMap.field;
            const calculatedValue: FAM_TValue = {
                type: 'date',
                value: dateAPlusNMonths
            };
            const fieldValue = bcbs_runoutclaimsenddate_fieldMap.field.values[0];

            // custom action
            onUpdate(calculatedValue, field, fieldValue);
        }
    }
}